webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// The browser platform with a compiler
	// Application is using dynamic bootstrapping wit JIT (Just-In-Time) compiler
	var platform_browser_dynamic_1 = __webpack_require__(1);
	// The app module
	var AppModule_1 = __webpack_require__(23);
	var core_1 = __webpack_require__(3);
	core_1.enableProdMode();
	// Combine and launch the module
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(AppModule_1.AppModule);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var shared_1 = __webpack_require__(24);
	var core_2 = __webpack_require__(71);
	var admin_1 = __webpack_require__(120);
	var SessionService_1 = __webpack_require__(110);
	var LocalNetworkService_1 = __webpack_require__(87);
	var AppComponent_1 = __webpack_require__(129);
	var AppRouting_1 = __webpack_require__(146);
	var NavigateComponent_1 = __webpack_require__(147);
	var UserService_1 = __webpack_require__(98);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    return AppModule;
	}());
	AppModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            platform_browser_1.BrowserModule,
	            core_2.CoreModule,
	            shared_1.SharedModule,
	            admin_1.AdminModule,
	            AppRouting_1.routing
	        ],
	        declarations: [
	            AppComponent_1.AppComponent,
	            NavigateComponent_1.NavigateComponent,
	        ],
	        providers: [
	            SessionService_1.SessionService,
	            LocalNetworkService_1.LocalNetworkService,
	            UserService_1.UserService
	        ],
	        bootstrap: [
	            AppComponent_1.AppComponent,
	        ]
	    })
	], AppModule);
	exports.AppModule = AppModule;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(25));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var forms_1 = __webpack_require__(26);
	var http_1 = __webpack_require__(30);
	var components_1 = __webpack_require__(31);
	var SharedModule = (function () {
	    /**
	     * The SharedModule which will define the modules, components & directives that will
	     * be used again in other feature modules. It 's different with the CoreModule which
	     * will define the components, directives that only use one time in the main AppModule.
	     */
	    function SharedModule() {
	    }
	    return SharedModule;
	}());
	SharedModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	        ],
	        declarations: [
	            components_1.AlertBoxComponent,
	            components_1.PaginatorComponent,
	            components_1.CalendarComponent
	        ],
	        exports: [
	            // Modules
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	            // Components
	            components_1.AlertBoxComponent,
	            components_1.PaginatorComponent,
	            components_1.CalendarComponent
	        ]
	    })
	    /**
	     * The SharedModule which will define the modules, components & directives that will
	     * be used again in other feature modules. It 's different with the CoreModule which
	     * will define the components, directives that only use one time in the main AppModule.
	     */
	], SharedModule);
	exports.SharedModule = SharedModule;


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(32));
	__export(__webpack_require__(35));
	__export(__webpack_require__(38));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var AlertBoxComponent = (function () {
	    function AlertBoxComponent() {
	    }
	    AlertBoxComponent.prototype.ngOnInit = function () {
	        // Set default message type if no type input received.
	        if (!this.type) {
	            this.type = "warning";
	        }
	    };
	    AlertBoxComponent.prototype.onClose = function () {
	        // Set message to "" to hide the box.
	        this.message = "";
	    };
	    return AlertBoxComponent;
	}());
	__decorate([
	    core_1.Input('message'),
	    __metadata("design:type", String)
	], AlertBoxComponent.prototype, "message", void 0);
	__decorate([
	    core_1.Input('type'),
	    __metadata("design:type", String)
	], AlertBoxComponent.prototype, "type", void 0);
	AlertBoxComponent = __decorate([
	    core_1.Component({
	        selector: 'alert-box',
	        template: __webpack_require__(33),
	        styles: [__webpack_require__(34)]
	    }),
	    core_1.Injectable()
	], AlertBoxComponent);
	exports.AlertBoxComponent = AlertBoxComponent;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"callout\" [ngClass]=\"type\" [class.hidden]=\"!message\">\n    {{message}}\n    <button class=\"close-button\" type=\"button\" (click)=\"onClose()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>";

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = ".callout{padding:0.5rem 1.5rem 0.5rem 0.5rem;opacity:1;visibility:visible;transition:all ease-in-out 0.2s}.callout.hidden{visibility:hidden;opacity:0;padding:0;margin:0}.callout button.close-button{right:0.5rem;line-height:0.7}\n"

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var PaginatorComponent = (function () {
	    function PaginatorComponent() {
	        this.currentPageUpdated = new core_1.EventEmitter();
	    }
	    PaginatorComponent.prototype.ngOnInit = function () {
	        if (this.currentPage > this.totalPage) {
	            this.currentPage = 1;
	        }
	        this.oldTotalPage = this.totalPage;
	        // Generate page number range list that will be used to display.
	        this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	    };
	    PaginatorComponent.prototype.ngOnChanges = function (changes) {
	        for (var propName in changes) {
	            if (propName === 'totalPage' && changes[propName].currentValue > 0) {
	                // Re-generate page number range list that will be used to display.
	                this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	            }
	            if (propName === 'currentPage') {
	                if (this.pageList && this.pageList.indexOf(changes[propName].currentValue) === -1) {
	                    // Re-generate page number range list that will be used to display.
	                    this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	                }
	            }
	        }
	    };
	    PaginatorComponent.prototype.generatePageNumberList = function (numberDisplay, currentPage, totalPage) {
	        var pageNumberList = [];
	        var range = Math.floor(numberDisplay / 2);
	        var start = 0;
	        var end = currentPage + range > totalPage ? totalPage : currentPage + range;
	        // Generate start number
	        if (currentPage - range > 0) {
	            start = currentPage + range > totalPage ? totalPage - numberDisplay + 1 : currentPage - range;
	            start = start < 1 ? start = 1 : start;
	        }
	        else {
	            start = 1;
	        }
	        // Generate end number
	        end = start + numberDisplay - 1 > totalPage ? totalPage : start + numberDisplay - 1;
	        for (start; start <= end; start++) {
	            pageNumberList.push(start);
	        }
	        return pageNumberList;
	    };
	    PaginatorComponent.prototype.updateSelectedPage = function (page) {
	        if (page > 0 && page <= this.totalPage) {
	            // Update current Page
	            this.currentPage = page;
	            // generate new page list
	            this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	            // Fire event for parent component to know current page had been changed
	            this.currentPageUpdated.emit(page);
	        }
	    };
	    return PaginatorComponent;
	}());
	__decorate([
	    core_1.Input('currentPage'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "currentPage", void 0);
	__decorate([
	    core_1.Input('totalPage'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "totalPage", void 0);
	__decorate([
	    core_1.Input('numberDisplay'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "numberDisplay", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], PaginatorComponent.prototype, "currentPageUpdated", void 0);
	PaginatorComponent = __decorate([
	    core_1.Component({
	        selector: 'pagination',
	        template: __webpack_require__(36),
	        styles: [__webpack_require__(37)]
	    }),
	    core_1.Injectable()
	], PaginatorComponent);
	exports.PaginatorComponent = PaginatorComponent;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"text-center\" *ngIf=\"totalPage>1\">\n    <ul class=\"paginator\">\n        <!-- First Page -->\n        <li [class.disabled]=\"currentPage === 1\" title=\"First page\" (click)=\"updateSelectedPage(1)\">\n            <i class=\"material-icons\">first_page</i>\n        </li>\n        <!-- Previous Page -->\n        <li [class.disabled]=\"currentPage === 1\" title=\"Previous page\" (click)=\"updateSelectedPage(currentPage - 1)\">\n            <i class=\"material-icons\">keyboard_arrow_left</i>\n        </li>\n        <!-- Pages -->\n        <li *ngFor=\"let page of pageList\" [class.current]=\"page === currentPage\" (click)=\"updateSelectedPage(page)\">\n            {{page}}\n        </li>\n\n        <!-- Next Page -->\n        <li title=\"Next page\" (click)=\"updateSelectedPage(currentPage + 1)\" [class.disabled]=\"currentPage === totalPage\">\n            <i class=\"material-icons\">keyboard_arrow_right</i>\n        </li>\n        <!-- Last Page -->\n        <li title=\"Last page\" (click)=\"updateSelectedPage(totalPage)\" [class.disabled]=\"currentPage === totalPage\">\n            <i class=\"material-icons\">last_page</i>\n        </li>\n    </ul>\n</div>";

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = "ul.paginator{display:inline-flex;display:-webkit-inline-flex;margin:1rem}ul.paginator li{margin:0 0.2rem;border:1px #043d7a solid;border-radius:0.2rem;padding:0.2rem;vertical-align:middle;display:inline-block;color:#043d7a;text-align:center;width:2rem;cursor:pointer}ul.paginator li.disabled{opacity:0.25;cursor:not-allowed}ul.paginator li:not(.disabled):hover{background-color:#043d7a;color:#fff}ul.paginator li.current{background-color:#043d7a;color:#fff;cursor:default}\n"

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(39);
	// import { User, UserService } from "../../../user";
	var CalendarComponent = (function () {
	    // private userData: User;
	    function CalendarComponent(router) {
	        this.router = router;
	    }
	    CalendarComponent.prototype.ngOnInit = function () {
	        //check auth later
	        // this.userData = this.userService.getUserSessionData();
	        // if (!this.userData) {
	        //   this.router.navigate(["/"]);
	        // }
	    };
	    return CalendarComponent;
	}());
	CalendarComponent = __decorate([
	    core_1.Component({
	        selector: "calendar-ais",
	        template: __webpack_require__(69),
	        styles: [__webpack_require__(70)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router])
	], CalendarComponent);
	exports.CalendarComponent = CalendarComponent;


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports) {

	module.exports = "<main>\n  <div class=\"component-title\">\n    <h1 style=\"text-align: center\">AIS EVENTS CALENDAR</h1>\n  </div>\n  <div class=\"container\">\n    <div class=\"list-activity\">\n      <ul class=\"tabs\">\n        <li class=\"tabs-title\" style = \"width: 100%\">\n          <h3>AIS Primary Key</h3>\n          <!--Tab content-->\n          <ul class=\"tab-content\">\n            <div>\n              <iframe\n                src=\"https://outlook.office365.com/calendar/published/8bbd188021a84c35acecf687b51a7650@aisvietnam.com/f9e0af964a3e4c0592230601cb9d840a15610149895430689436/calendar.html\"\n                scrolling=\"no\"\n                width=\"100%\"\n                height=\"700\"\n                frameborder=\"0\"\n                webkitallowfullscreen mozallowfullscreen allowfullscreen\n              ></iframe>\n            </div>\n          </ul>\n          <!--End of Tab content-->\n        </li>\n        <li class=\"tabs-title secondary\" style=\"width: 100%;margin-left: 0px;\">\n          <h3>AIS Secondary Key</h3>\n          <!--Tab content-->\n          <ul class=\"tab-content\">\n            <div>\n              <iframe\n                src=\"https://outlook.office365.com/calendar/published/8bbd188021a84c35acecf687b51a7650@aisvietnam.com/9f34949e334b48858c4227cd20ccc9ed7215315901799778642/calendar.html\"\n                scrolling=\"no\"\n                width=\"100%\"\n                height=\"700\"\n                frameborder=\"0\"\n                webkitallowfullscreen mozallowfullscreen allowfullscreen\n              ></iframe>\n            </div>\n          </ul>\n          <!--End of Tab content-->\n        </li>\n      </ul>\n    </div>\n  </div>\n\n  <div id=\"daisy_from\" style=\"display: none\"></div>\n</main>\n";

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = ".btn-popup{padding:15px;width:142px}.clickable{cursor:pointer}li{padding:0 1rem}form{padding:0;border:none;box-shadow:none;background:none}.component-title{color:#043d7a;background-color:#f8f8f8;padding:1.5rem 0;border-bottom:1px solid #eaeaea}.component-title h1{width:80%;margin:0 auto;padding:0 1.25rem;font-size:1.5256rem}.container{width:98%;margin:0 auto;padding:0}.container li{margin:0}.container .list-activity{padding:0}.container .list-activity ul{margin:0 auto;margin-bottom:3rem}.container .list-activity ul .secondary{margin-left:50px}.container .list-activity ul h3{padding:10px;font-size:2rem}@media only screen and (min-width: 769px) and (max-width: 1024px){.container{overflow-x:hidden}.container .secondary{margin-left:0 !important}}@media only screen and (max-width: 768px){li{flex:0 0 50%}.component-title{width:100% !important}.container{width:768px !important;overflow-x:hidden}.container .secondary{margin-left:0 !important}}\n"

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(72));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Shared Modules
	var common_1 = __webpack_require__(22);
	var router_1 = __webpack_require__(39);
	// Shared Services
	var services_1 = __webpack_require__(73);
	// Components
	var FooterComponent_1 = __webpack_require__(88);
	var InspiredComponent_1 = __webpack_require__(94);
	var MainMenuComponent_1 = __webpack_require__(97);
	var TopMenuComponent_1 = __webpack_require__(105);
	var MenuHoverDirective_1 = __webpack_require__(108);
	var AdminHeaderComponent_1 = __webpack_require__(109);
	var AdminHeaderAuthComponent_1 = __webpack_require__(113);
	var AdminSidebarComponent_1 = __webpack_require__(116);
	// Services
	var AdminService_1 = __webpack_require__(101);
	var services_2 = __webpack_require__(119);
	var HolidayService_1 = __webpack_require__(100);
	var CoreModule = (function () {
	    function CoreModule(parentModule) {
	        // Guard to make sure that the CoreModule will be loaded one time only in the AppModule
	        if (parentModule) {
	            throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
	        }
	    }
	    return CoreModule;
	}());
	CoreModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            router_1.RouterModule
	        ],
	        declarations: [
	            FooterComponent_1.FooterComponent,
	            MainMenuComponent_1.MainMenuComponent,
	            TopMenuComponent_1.TopMenuComponent,
	            MenuHoverDirective_1.MenuHoverDirective,
	            AdminHeaderComponent_1.AdminHeaderComponent,
	            AdminSidebarComponent_1.AdminSidebarComponent,
	            InspiredComponent_1.InspiredComponent,
	            AdminHeaderAuthComponent_1.AdminHeaderAuthComponent
	        ],
	        providers: [
	            // Services
	            services_1.SettingService,
	            services_1.ApiService,
	            services_1.LocalStorageService,
	            services_1.SessionStorageService,
	            services_1.FileService,
	            services_1.CatalogService,
	            services_1.StudentService,
	            services_1.MenuService,
	            AdminService_1.AdminService,
	            services_1.LocalNetworkService,
	            services_2.SessionService,
	            HolidayService_1.HolidayService
	        ],
	        exports: [
	            FooterComponent_1.FooterComponent,
	            MainMenuComponent_1.MainMenuComponent,
	            TopMenuComponent_1.TopMenuComponent,
	            MenuHoverDirective_1.MenuHoverDirective,
	            AdminHeaderComponent_1.AdminHeaderComponent,
	            AdminSidebarComponent_1.AdminSidebarComponent,
	            InspiredComponent_1.InspiredComponent,
	            AdminHeaderAuthComponent_1.AdminHeaderAuthComponent
	        ]
	    })
	    /**
	     * The CoreModule which will define the modules, components & directives that will
	     * be called only onetime in the main AppModule when the app loads. Do not import
	     * the CoreModule more than one time.
	     */
	    ,
	    __param(0, core_1.Optional()), __param(0, core_1.SkipSelf()),
	    __metadata("design:paramtypes", [CoreModule])
	], CoreModule);
	exports.CoreModule = CoreModule;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(74));
	__export(__webpack_require__(75));
	__export(__webpack_require__(81));
	__export(__webpack_require__(82));
	__export(__webpack_require__(76));
	__export(__webpack_require__(83));
	__export(__webpack_require__(80));
	__export(__webpack_require__(84));
	__export(__webpack_require__(87));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	var http_1 = __webpack_require__(30);
	var ApiService = (function () {
	    function ApiService(http) {
	        this.http = http;
	    }
	    /**
	     * Get Method to get data from Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.get = function (requestUrl) {
	        var options = new http_1.RequestOptions({ withCredentials: true });
	        return this.http.get(requestUrl, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Get Method to get data from Api Endpoint - Use to export pdf
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.getFile = function (requestUrl) {
	        var options = new http_1.RequestOptions({
	            withCredentials: true,
	        });
	        return this.http.get(requestUrl, options)
	            .map(function (response) {
	            var body = JSON.parse(response['_body']);
	            return body.buffer.data;
	        })
	            .catch(this.handleError);
	    };
	    /**
	     * Post Method to post data from Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.post = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.post(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Put Method to post data to Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.put = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.put(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Patch Method to update data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.patch = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            method: http_1.RequestMethod.Patch,
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.patch(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Delete Method to remove the data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.delete = function (requestUrl) {
	        var options = new http_1.RequestOptions({ withCredentials: true });
	        return this.http.delete(requestUrl, options)
	            .catch(this.handleError);
	    };
	    /**
	     * Delete Method to remove the data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.deletePost = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            method: http_1.RequestMethod.Delete,
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.post(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Extract Response data from Request Response
	     * @param res: Response
	     * @return JSON data
	     */
	    ApiService.prototype.extractData = function (res) {
	        var body;
	        var contentType = res.headers.get("content-type");
	        // If response has content type "application/json"
	        // then parse the body
	        if (contentType && contentType.indexOf('application/json') !== -1) {
	            try {
	                body = res.json();
	            }
	            catch (error) {
	                body = {};
	            }
	        }
	        else {
	            body = res.text();
	        }
	        return body;
	    };
	    /**
	     * Handle Error returned from Request Response
	     * @param error: any
	     * @return Observable<error>
	     */
	    ApiService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        // console.log(errMsg); // log to console instead
	        return Observable_1.Observable.throw(error);
	    };
	    return ApiService;
	}());
	ApiService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [http_1.Http])
	], ApiService);
	exports.ApiService = ApiService;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	// Services
	var ApiService_1 = __webpack_require__(74);
	var SettingService_1 = __webpack_require__(76);
	var FileService_1 = __webpack_require__(80);
	var CatalogService = (function () {
	    function CatalogService(apiService, settingService, fileService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.fileService = fileService;
	        this.fullCampusUrl = '/included-campuses';
	        this.campusUrl = '/campuses';
	        this.homeroomUrl = '/homerooms';
	        this.schoolyearUrl = '/school-years';
	        this.yearLevelUrl = '/year-levels';
	        this.semesterUrl = '/semesters';
	        this.termUrl = '/asa-terms';
	        this.currentSeasonUrl = '/seasons/currents';
	        this.allCurrentSeasonUrl = '/seasons/currents/all';
	        this.seasonUrl = '/seasons';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get campus items
	     * @returns {Observable<Campus[]>} Array list of Campus class
	     */
	    CatalogService.prototype.getCampuses = function () {
	        var requestUrl = this.apiUrl + this.campusUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get full campus item with contain yearlevels and homerooms.
	     * @returns {Observable<CampusFullItem[]>} Array list of CampusFullItem class
	     */
	    CatalogService.prototype.getCampusesFullItems = function () {
	        var requestUrl = this.apiUrl + this.fullCampusUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get homerooms
	     * @returns {Observable<Homeroom[]>} Array list of Homeroom class
	     */
	    CatalogService.prototype.getHomerooms = function () {
	        var requestUrl = this.apiUrl + this.homeroomUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get school years
	     * @returns {Observable<Schoolyear[]>} Array list of Schoolyear class
	     */
	    CatalogService.prototype.getSchoolyears = function () {
	        var requestUrl = this.apiUrl + this.schoolyearUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get year levels
	     * @returns {Observable<YearLevel[]>} Array list of YearLevel class
	     */
	    CatalogService.prototype.getYearLevels = function () {
	        var requestUrl = this.apiUrl + this.yearLevelUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getSemesters = function () {
	        var requestUrl = this.apiUrl + this.semesterUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getTerms = function () {
	        var requestUrl = this.apiUrl + this.termUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getSeason = function () {
	        var requestUrl = this.apiUrl + this.seasonUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getCurrentSeason = function () {
	        var requestUrl = this.apiUrl + this.currentSeasonUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getAllCurrentSeason = function () {
	        var requestUrl = this.apiUrl + this.allCurrentSeasonUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getTermBySemesterId = function (semesterId) {
	        var requestUrl = this.apiUrl + this.termUrl + '?semester_id=' + semesterId;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getTemrmByCurrentSemester = function () {
	        var _this = this;
	        return this.getSemesters()
	            .map(function (semesterList) { return _.filter(semesterList, function (o) { return o.is_current; })[0].id; })
	            .switchMap(function (currentSemesterId) { return currentSemesterId ? _this.getTermBySemesterId(currentSemesterId) : Observable_1.Observable.of(null); });
	    };
	    /**
	     * Handle Promise errors
	     * @returns {String} Message error
	     */
	    CatalogService.prototype.handleError = function (error) {
	        return Promise.reject(error.message || error);
	    };
	    return CatalogService;
	}());
	CatalogService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService,
	        FileService_1.FileService])
	], CatalogService);
	exports.CatalogService = CatalogService;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Setting configuration
	var Setting_1 = __webpack_require__(77);
	// Lodash
	var _ = __webpack_require__(78);
	var SettingService = (function () {
	    function SettingService() {
	    }
	    /**
	     * Find in the setting list the setting that has
	     * the id matched with settingId input
	     * @param {string} settingId - the id of the setting
	     * @return {string} - the setting value or empty string
	     */
	    SettingService.prototype.getSetting = function (settingId) {
	        var result = _.find(Setting_1.SETTINGS, { 'id': settingId });
	        return result ? result.value : '';
	    };
	    return SettingService;
	}());
	SettingService = __decorate([
	    core_1.Injectable()
	], SettingService);
	exports.SettingService = SettingService;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Setting = (function () {
	    function Setting() {
	    }
	    return Setting;
	}());
	exports.Setting = Setting;
	exports.SETTINGS = [
	    {
	        id: 'api_service_domain',
	        value: '/api'
	    }
	];


/***/ }),
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	// Import Setting Service and User, Credential Model
	var SettingService_1 = __webpack_require__(76);
	var ApiService_1 = __webpack_require__(74);
	var FileService = (function () {
	    function FileService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.fileUrl = '/files';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    FileService.prototype.uploadFile = function (data) {
	        var requestUrl = this.apiUrl + this.fileUrl;
	        return this.apiService.post(requestUrl, data);
	    };
	    FileService.prototype.getFile = function (fileId) {
	        return this.apiUrl + this.fileUrl + '/' + fileId;
	    };
	    return FileService;
	}());
	FileService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [SettingService_1.SettingService,
	        ApiService_1.ApiService])
	], FileService);
	exports.FileService = FileService;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var LocalStorageService = (function () {
	    function LocalStorageService() {
	    }
	    LocalStorageService.prototype.getData = function (key) {
	        var text = window.localStorage.getItem(key);
	        return JSON.parse(text);
	    };
	    LocalStorageService.prototype.setData = function (key, data) {
	        var text = JSON.stringify(data);
	        try {
	            window.localStorage.setItem(key, text);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot set local storage data:");
	            console.log(data);
	            return false;
	        }
	    };
	    LocalStorageService.prototype.removeData = function (key) {
	        try {
	            window.localStorage.removeItem(key);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot remove local storage data. Data key: " + key);
	            return false;
	        }
	    };
	    return LocalStorageService;
	}());
	LocalStorageService = __decorate([
	    core_1.Injectable()
	], LocalStorageService);
	exports.LocalStorageService = LocalStorageService;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var SessionStorageService = (function () {
	    function SessionStorageService() {
	    }
	    SessionStorageService.prototype.getData = function (key) {
	        var text = window.sessionStorage.getItem(key);
	        return text ? JSON.parse(text) : '';
	    };
	    SessionStorageService.prototype.setData = function (key, data) {
	        var text = JSON.stringify(data);
	        try {
	            window.sessionStorage.setItem(key, text);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot set local storage data:");
	            console.log(data);
	            return false;
	        }
	    };
	    SessionStorageService.prototype.removeData = function (key) {
	        try {
	            window.sessionStorage.removeItem(key);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot remove local storage data. Data key: " + key);
	            return false;
	        }
	    };
	    return SessionStorageService;
	}());
	SessionStorageService = __decorate([
	    core_1.Injectable()
	], SessionStorageService);
	exports.SessionStorageService = SessionStorageService;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var ApiService_1 = __webpack_require__(74);
	var SettingService_1 = __webpack_require__(76);
	var StudentService = (function () {
	    function StudentService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.studentUrl = '/students';
	        this.holidayStudentUrl = '/hol/student';
	        this.studentScheduleUrl = '/asa-required-class-children';
	        this.importStudentScheduleUrl = '/students-schedule';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     *
	     */
	    StudentService.prototype.getStudents = function (filter) {
	        var requestUrl = this.apiUrl + this.studentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudents = function (holidayStudentFilter) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in holidayStudentFilter) {
	            if (holidayStudentFilter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + holidayStudentFilter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudentDetail = function (studentId) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl + '?id=' + studentId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.updateHolidayStudentStatus = function (data) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        // Post content
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    StudentService.prototype.getStudentsSchedule = function (filter) {
	        var requestUrl = this.apiUrl + this.studentScheduleUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudentInfo = function () {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.importStudent = function (data) {
	        var requestUrl = this.apiUrl + this.studentUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    StudentService.prototype.importStudentSchedule = function (data) {
	        var requestUrl = this.apiUrl + this.importStudentScheduleUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    StudentService.prototype.updateStudentStatus = function (studentId, data) {
	        var requestUrl = this.apiUrl + this.studentUrl + "/" + studentId;
	        // Post content
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // Edit student
	    StudentService.prototype.editHolidayStudent = function (studentDetail) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        var body = JSON.stringify(studentDetail);
	        return this.apiService.patch(requestUrl, body);
	    };
	    //generate list season with day
	    StudentService.prototype.showClassBySeasonAndDay = function (season, weekdays) {
	        var iWeekdaysLength = weekdays.length;
	        var tempCompareName;
	        for (var i = 0; i < iWeekdaysLength; i++) {
	            tempCompareName = "" + weekdays[i].day;
	            if (_.parseInt(weekdays[i].season_id) === season.id && tempCompareName.toLowerCase() === season.displayName.toLowerCase()) {
	                return weekdays[i].class || weekdays[i].class_info.name;
	            }
	        }
	        return '';
	    };
	    return StudentService;
	}());
	StudentService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService])
	], StudentService);
	exports.StudentService = StudentService;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Menu for application
	var Menu_1 = __webpack_require__(85);
	var CampusInfo_1 = __webpack_require__(86);
	// Lodash
	var _ = __webpack_require__(78);
	var MenuService = (function () {
	    function MenuService() {
	    }
	    /**
	     * Find in the menu type list the menu list that has
	     * the name matched with menuType input
	     * @param {string} menuType - the name of the menu list
	     * @return { Menu[] | [] } - list of menu or empty list
	     */
	    MenuService.prototype.getMenuList = function (menuType) {
	        var result = _.find(Menu_1.MENUS, { 'name': menuType });
	        return result ? result.menuList : [];
	    };
	    MenuService.prototype.getCampusInfo = function () {
	        return CampusInfo_1.CAMPUS_INFOS;
	    };
	    return MenuService;
	}());
	MenuService = __decorate([
	    core_1.Injectable()
	], MenuService);
	exports.MenuService = MenuService;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Menu = (function () {
	    function Menu() {
	    }
	    return Menu;
	}());
	exports.Menu = Menu;
	var MenuType = (function () {
	    function MenuType() {
	    }
	    return MenuType;
	}());
	exports.MenuType = MenuType;
	var MenuStatus = (function () {
	    function MenuStatus() {
	    }
	    return MenuStatus;
	}());
	exports.MenuStatus = MenuStatus;
	exports.MENUS = [
	    // Top menu list
	    {
	        name: 'top',
	        menuList: [
	            {
	                id: 'news-event',
	                label: 'News & Events',
	                url: 'https://www.aisvietnam.com/community/news-events/',
	                type: 'link',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'photo-gallery',
	                label: 'Photo Gallery',
	                url: 'https://www.aisvietnam.com/about-us/our-campuses/',
	                type: 'link',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'login-mail',
	                label: 'Login Mail',
	                url: 'https://portal.office.com',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'my-ais',
	                label: 'myAIS',
	                url: 'http://www.myais.vn',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'sitemap',
	                label: 'Sitemap',
	                url: 'https://www.aisvietnam.com/contact/',
	                type: 'link',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Social connect top menu list
	    {
	        name: 'social-top',
	        menuList: [
	            {
	                id: 'facebook',
	                label: 'Facebook',
	                url: 'https://www.facebook.com/AustralianInternationalSchoolVietnam/',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'twitter',
	                label: 'Twitter',
	                url: 'https://twitter.com/#!/aisvietnam',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'google',
	                label: 'Google',
	                url: 'https://plus.google.com/u/0/+AustralianInternationalSchoolVietnamTT/posts',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'youtube',
	                label: 'Youtube',
	                url: 'https://www.youtube.com/user/aisvietnam',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'envelope-o',
	                label: 'Email',
	                url: 'http://portal.office.com/',
	                type: 'link',
	                target: '_blank',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Login main menu
	    {
	        name: 'login-main',
	        menuList: [
	            {
	                id: 'register',
	                label: 'Register',
	                url: '/hol-register',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'login',
	                label: 'Login',
	                url: '/hol-login',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Login main menu
	    {
	        name: 'hol-login',
	        menuList: [
	            {
	                id: 'register',
	                label: 'Register',
	                url: '/hol-register',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'login',
	                label: 'Login',
	                url: '/hol-login',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Camp module main menu list
	    {
	        name: 'camp-main',
	        menuList: []
	    },
	    // ASA module main menu list
	    {
	        name: 'asa-main',
	        menuList: []
	    },
	    // ASA module sub menu list
	    {
	        name: 'asa-sub',
	        menuList: [
	            {
	                id: 'bookingClasses',
	                label: 'Booking Classes',
	                url: '/booking/students',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            // {
	            //     "id": "manageBooking",
	            //     "label": "Manage Booking",
	            //     "url":	"",
	            //     "type":	"route",
	            //     "target": "",
	            //     "icon": "",
	            //     "role": []
	            // },
	            {
	                id: 'attendance',
	                label: 'Attendance',
	                url: '/parent/attendance',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'schedule',
	                label: 'Schedule',
	                url: '/schedule/list',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // Camp module admin sidebar list
	    {
	        name: 'camp-admin-sidebar',
	        menuList: [
	            {
	                id: 'camp-program',
	                label: 'Camp Programmes',
	                url: '/camps/list',
	                type: 'route',
	                target: '',
	                icon: 'nature_people',
	                role: []
	            },
	            {
	                id: 'student',
	                label: 'Students',
	                url: '/students/list',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: []
	            },
	            {
	                id: 'camp-report',
	                label: 'Camp Reports',
	                url: '/camps/report',
	                type: 'route',
	                target: '',
	                icon: 'rate_review',
	                role: []
	            }
	        ]
	    },
	    // Asa module admin sidebar list
	    {
	        name: 'asa-admin-sidebar',
	        menuList: [
	            {
	                id: 'classes',
	                label: 'Classes',
	                url: '/classes/list',
	                type: 'route',
	                target: '',
	                icon: 'store',
	                role: []
	            },
	            {
	                id: 'student',
	                label: 'Students',
	                url: '/students/list',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: []
	            },
	            {
	                id: 'booking',
	                label: 'Bookings',
	                url: '/booking/list',
	                type: 'route',
	                target: '',
	                icon: 'bookmark',
	                role: []
	            },
	            {
	                id: 'email',
	                label: 'Email',
	                url: '/email/list',
	                type: 'route',
	                target: '',
	                icon: 'mail',
	                role: []
	            },
	            {
	                id: 'attendances',
	                label: 'Attendances',
	                url: '/attendances',
	                type: 'route',
	                target: '',
	                icon: 'spellcheck',
	                role: []
	            },
	            {
	                id: 'settings',
	                label: 'Settings',
	                url: '/settings',
	                type: 'route',
	                target: '',
	                icon: 'settings',
	                role: []
	            }
	        ]
	    },
	    // Bus module parent sidebar list
	    {
	        name: 'bus-parent-sidebar',
	        menuList: [
	            {
	                id: 'bus-attendance',
	                label: 'Bus attendance',
	                url: '',
	                type: 'route',
	                target: '',
	                icon: 'store',
	                role: []
	            },
	            {
	                id: 'bus-profile',
	                label: 'Profile',
	                url: '',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: []
	            }
	        ]
	    },
	    // Bus module parent sidebar list
	    {
	        name: 'bus-admin-sidebar',
	        menuList: [
	            {
	                id: 'bus-schedule',
	                label: 'Daily transport list',
	                url: 'bus-schedules',
	                type: 'route',
	                target: '',
	                icon: 'directions_bus',
	                role: ['system', 'manager']
	            },
	            {
	                id: 'bus-student-management',
	                label: 'Student report',
	                url: 'students/list',
	                type: 'route',
	                target: '',
	                icon: 'assignment_ind',
	                role: ['system']
	            },
	            {
	                id: 'bus-report',
	                label: 'Bus report',
	                url: 'report',
	                type: 'route',
	                target: '',
	                icon: 'assessment',
	                role: ['system']
	            },
	            {
	                id: 'bus-settings',
	                label: 'Settings',
	                url: 'settings',
	                type: 'route',
	                target: '',
	                icon: 'settings',
	                role: ['system']
	            }
	        ]
	    },
	    // Holiday module main menu list
	    {
	        name: 'holiday-main',
	        menuList: []
	    },
	    // holiday module admin sidebar list
	    {
	        name: 'holiday-admin-sidebar',
	        menuList: [
	            {
	                id: 'booking',
	                label: 'Bookings',
	                url: '/booking/list',
	                type: 'route',
	                target: '',
	                icon: 'bookmark',
	                role: ['system']
	            },
	            {
	                id: 'courses',
	                label: 'Courses',
	                url: '/courses/list',
	                type: 'route',
	                target: '',
	                icon: 'book',
	                role: ['system']
	            },
	            {
	                id: 'classes',
	                label: 'Classes',
	                url: '/classes/list',
	                type: 'route',
	                target: '',
	                icon: 'store',
	                role: ['system', 'manager']
	            },
	            {
	                id: 'student',
	                label: 'Students',
	                url: '/students/list',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: ['system']
	            },
	            {
	                id: 'email',
	                label: 'Email',
	                url: '/email/list',
	                type: 'route',
	                target: '',
	                icon: 'mail',
	                role: ['system', 'manager']
	            },
	            {
	                id: 'attendances',
	                label: 'Attendances',
	                url: '/attendances',
	                type: 'route',
	                target: '',
	                icon: 'spellcheck',
	                role: ['system', 'manager']
	            },
	            {
	                id: 'parents',
	                label: 'Parents',
	                url: '/parents',
	                type: 'route',
	                target: '',
	                icon: 'people',
	                role: ['system']
	            },
	            {
	                id: 'setting',
	                label: 'Setting',
	                url: '/setting',
	                type: 'route',
	                target: '',
	                icon: 'widgets',
	                role: ['system']
	            }
	        ]
	    },
	    {
	        name: 'holiday-staff-sidebar',
	        menuList: [
	            {
	                id: 'attendances',
	                label: 'Attendances',
	                url: '/attendances',
	                type: 'route',
	                target: '',
	                icon: 'spellcheck',
	                role: []
	            }
	        ]
	    },
	    // Holiday parent sub menu
	    {
	        name: 'holiday-sub',
	        menuList: [
	            {
	                id: 'holidayBooking',
	                label: 'Booking',
	                url: '/booking/students',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            },
	            {
	                id: 'holidayAttendance',
	                label: 'Attendance',
	                url: '/view-attendance',
	                type: 'route',
	                target: '',
	                icon: '',
	                role: []
	            }
	        ]
	    },
	    // re-enrollment module admin sidebar list
	    {
	        name: 'reen-admin-sidebar',
	        menuList: [
	            {
	                id: 'response',
	                label: 'Responses',
	                url: '/response/list',
	                type: 'route',
	                target: '',
	                icon: 'bookmark',
	                role: ['system']
	            },
	            {
	                id: 'email',
	                label: 'Email',
	                url: '/email/list',
	                type: 'route',
	                target: '',
	                icon: 'email',
	                role: ['system']
	            },
	            {
	                id: 'student',
	                label: 'Students',
	                url: '/reen-student',
	                type: 'route',
	                target: '',
	                icon: 'store',
	                role: ['system']
	            },
	            {
	                id: 'report',
	                label: 'Report',
	                url: '/report',
	                type: 'route',
	                target: '',
	                icon: 'assessment',
	                role: ['system']
	            }
	        ]
	    },
	    // conference booking system module admin sidebar list
	    // role example : 'system', 'manager', 'parent'
	    {
	        name: 'conference-admin-sidebar',
	        menuList: [
	            {
	                id: 'interviews',
	                label: 'Booking rounds',
	                url: '/interviews',
	                type: 'route',
	                target: '',
	                icon: 'dashboard',
	                role: ['system'],
	            },
	            {
	                id: 'setting',
	                label: 'Settings',
	                url: '/setting',
	                type: 'route',
	                target: '',
	                icon: 'build',
	                role: ['system']
	            },
	            {
	                id: 'master-data',
	                label: 'Master Data',
	                url: '/master-data',
	                type: 'route',
	                target: '',
	                icon: 'storage',
	                role: ['system']
	            },
	            {
	                id: 'manage-time-slots',
	                label: 'Manage Time Slots',
	                url: '/manage-time-slots',
	                type: 'route',
	                target: '',
	                icon: 'timeline',
	                role: ['system', 'teacher']
	            },
	            {
	                id: 'booking-interview-master',
	                label: 'Parent Booking',
	                url: '/manage-interview',
	                type: 'route',
	                target: '',
	                icon: 'date_range',
	                role: ['system']
	            },
	            {
	                id: 'booking-interview-teacher',
	                label: 'Manage Interview',
	                url: '/manage-interview/my-interview',
	                type: 'route',
	                target: '',
	                icon: 'date_range',
	                role: ['teacher']
	            },
	            {
	                id: 'user-management',
	                label: 'User Management',
	                url: '/user-management',
	                type: 'route',
	                target: '',
	                icon: 'group',
	                role: ['system']
	            },
	            {
	                id: 'report',
	                label: 'Report',
	                url: '/report',
	                type: 'route',
	                target: '',
	                icon: 'insert_chart',
	                role: ['system']
	            }
	        ]
	    }
	];


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CampusInfo = (function () {
	    function CampusInfo() {
	    }
	    return CampusInfo;
	}());
	exports.CampusInfo = CampusInfo;
	// Campus Info
	exports.CAMPUS_INFOS = [
	    {
	        id: 1,
	        name: "THU THIEM",
	        info: "Thu Thiem Campus (Kindergarten – Year 13)<br>264 Mai Chi Tho (East-West Highway), Binh Trung Ward | Ho Chi Minh City | Vietnam<br>T: +84 28 3742 4040",
	    },
	    {
	        id: 1,
	        name: "THAO DIEN",
	        info: "Thao Dien Campus (Kindergarten – Year 6)<br>APSC Compound 36 Thao Dien Road, An Khanh Ward | Ho Chi Minh City | Vietnam<br>T: +84 28 3744 6960 <br><br> Lotus Campus (Kindergarten) | Lotus Road<br> Cherry Blossom Campus (Year 1 – Year 6) | Cherry Blossom Road<br>T: +84 28 3744 6960",
	    },
	];


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var ApiService_1 = __webpack_require__(74);
	var SettingService_1 = __webpack_require__(76);
	var LocalNetworkService = (function () {
	    function LocalNetworkService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    LocalNetworkService.prototype.getLocalNetWork = function () {
	        this.hostName = window.location.hostname;
	        if (this.hostName === "auth.aisvietnam.com") {
	            var requestUrl = 'http://auth.aisvietnam.com/negotiate';
	            return this.apiService.get(requestUrl);
	        }
	        else {
	            var requestUrl = 'http://auth.eca.dev.nascorp.vn/negotiate';
	            return this.apiService.get(requestUrl);
	        }
	    };
	    return LocalNetworkService;
	}());
	LocalNetworkService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService])
	], LocalNetworkService);
	exports.LocalNetworkService = LocalNetworkService;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(84);
	var FooterComponent = (function () {
	    function FooterComponent(menuService) {
	        this.menuService = menuService;
	    }
	    FooterComponent.prototype.ngOnInit = function () {
	        /** TO DO
	         * Get current language from cookie/session
	         * If no language data from it, set default language as English
	         */
	        this.currentLang = 'en';
	        // Get top menu list
	        this.menuList = this.menuService.getMenuList('top');
	        // Get campus info list
	        this.campusList = this.menuService.getCampusInfo();
	    };
	    return FooterComponent;
	}());
	FooterComponent = __decorate([
	    core_1.Component({
	        selector: 'footer',
	        template: __webpack_require__(89),
	        styles: [__webpack_require__(93)],
	        providers: [MenuService_1.MenuService]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService])
	], FooterComponent);
	exports.FooterComponent = FooterComponent;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-footer\">\n    <!-- Trường quốc tế Úc -->\n    <div class=\"campus-info-list row small-up-1 medium-up-2 large-up-3\">\n        <!-- Campus Information -->\n        <div class=\"column\" *ngFor=\"let campus of campusList\">\n            <h5 class=\"campus-title\">{{campus.name}}</h5>\n            <div class=\"campus-text\" [innerHTML]=\"campus.info\"></div>\n        </div>\n\t\t<!-- CIS Member -->\n        <div class=\"column\">\n            <p align=\"center\">\n                <a href=\"http://www.ibo.org/\" target=\"_blank\"><img src=\"" + __webpack_require__(90) + "\"></a>\n            </p>\n            <p align=\"center\">\n                <a href=\"https://www.cam.ac.uk/\" target=\"_blank\"><img src=\"" + __webpack_require__(91) + "\"></a>\n            </p>\n            <p align=\"center\" class=\"cis-membership\">\n                <a href=\"http://www.cois.org/\" target=\"_blank\"><img src=\"" + __webpack_require__(92) + "\"></a>\n                <br>\n            </p>\n        </div>\n    </div>\n\t<div class=\"info-mail-container\">\n        <p class=\"info-mail-text\">enrolments@aisvietnam.com<br>www.aisvietnam.com</p>\n    </div>\n    <!-- Bottom Bar -->\n    <div class=\"bottom-bar\">\n        <div class=\"copyright\">\n            <span>Our website is best viewed using Chrome, Firefox, Safari.</span>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ib_logo.88ef45dabda5b2bbe32eb13597007f28.png";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cambridge_university_logo.859556d1e042809d4e685d9a2cc5d205.png";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cis_member_logo.a242bba236677d42272753977e9911d3.png";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "#app-footer{background-color:#225da8;font-size:0.7rem;bottom:0;bottom-position:absolute;bottom-width:100%}#app-footer .campus-info-list{max-width:100%;padding:2rem 4rem}#app-footer .campus-info-list .column .campus-title{text-transform:uppercase;font-weight:bold;font-size:1rem;color:#fff}#app-footer .campus-info-list .column .campus-text,#app-footer .campus-info-list .column .cis-membership{color:#dadada;line-height:1.375rem}#app-footer .bottom-bar{display:table;width:100%;background-color:#043d7a;padding:15px 4rem}#app-footer .bottom-bar .copyright{float:right;display:table-cell;vertical-align:middle}#app-footer .bottom-bar .copyright span{font-weight:bold;color:#faa635}#app-footer .bottom-bar .top-bar-right{float:right}#app-footer .bottom-bar .top-bar-right .menu>li>a{color:#faa635;padding:0.6rem 0.3rem}#app-footer .bottom-bar .top-bar-right .menu>li>a:hover{color:#fff}#app-footer .info-mail-container{text-align:left;padding-left:5rem;padding-top:1rem;padding-bottom:1rem}#app-footer .info-mail-text{color:white}@media only screen and (max-width: 40em){#app-footer{font-size:0.8rem}#app-footer .campus-info-list .column{padding:1rem 0}#app-footer .campus-info-list .column .campus-title{font-size:1rem}#app-footer .bottom-bar .copyright{padding:0.5rem;text-align:center}#app-footer .bottom-bar .top-bar-right{display:none}}\n"

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var InspiredComponent = (function () {
	    function InspiredComponent() {
	    }
	    InspiredComponent.prototype.ngOnInit = function () {
	        this.isShowContent = {
	            isShowContentEurope: false,
	            isShowContentAfrica: false,
	            isShowContentAsia: false,
	            isShowContentLatin: false,
	        };
	    };
	    InspiredComponent.prototype.showContent = function (key) {
	        for (var k in this.isShowContent) {
	            if ("" + k === Object.keys(this.isShowContent)[key]) {
	                this.isShowContent[k] = !this.isShowContent[k];
	            }
	            else {
	                this.isShowContent[k] = false;
	            }
	        }
	    };
	    return InspiredComponent;
	}());
	InspiredComponent = __decorate([
	    core_1.Component({
	        selector: 'inspired',
	        template: __webpack_require__(95),
	        styles: [__webpack_require__(96)],
	        animations: [
	            core_1.trigger('openClose', [
	                core_1.state('open', core_1.style({
	                    display: 'block',
	                    position: 'relative',
	                    zIndex: '10',
	                    opacity: '1',
	                })),
	                core_1.state('closed', core_1.style({
	                    height: '0',
	                    display: 'none',
	                    opacity: '0',
	                    overflow: 'hidden',
	                })),
	                core_1.transition('open <=> closed', [
	                    core_1.animate('300ms')
	                ])
	            ]),
	        ],
	    }),
	    __metadata("design:paramtypes", [])
	], InspiredComponent);
	exports.InspiredComponent = InspiredComponent;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = "<!-- Inspried -->\n<div class=\"inspired\">\n\t<div class=\"member-inspried\">\n\t\t<!--Start Inspried logo -->\n\t\t<a class=\"inspried-logo\" href=\"#\">\n\t\t\t<img src=\"https://services.aisvietnam.com/upload/footer_img_logo.jpg\" alt=\"footer_logo\" />\n\t\t</a>\n\t\t<!--End Inspried logo -->\n\n\t\t<!--Start Inspried content -->\n\t\t<div class=\"inspried-content-wrap\">\n\t\t\t<div tabindex=\"0\" class=\"inspried-content\"\n\t\t\t\t[@openClose]=\"isShowContent.isShowContentEurope ? 'open' : 'closed'\">\n\t\t\t\t<a href=\"http://fulham.school\">Fulham School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://reddamhouse.org.uk/\">Reddam House Berkshire</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://stgeorges.ch\">St. George's International School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://ecole-riviera.ch/\">Ecole Riviera</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://inspirededu.com/school/st-george-s-international-school-preview\">St. George's\n\t\t\t\t\tInternational School Preview</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.isticino.com/\">International School of Europe Ticino</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://sis.ac/\">Sotogrande International School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.sanpatricio.es/\">Colegio San Patricio El Soto</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.sanpatricio.es/\">Colegio San Patricio La Moraleja</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.sanpatricio.es/\">Colegio San Patricio Serrano</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.sanpatricio.es/\">Colegio San Patricio Toledo</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.park-is.com/\">PaRK International School Alfragide</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.park-is.com/\">PaRK International School Cascais</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.park-is.com/\">PaRK International School Praca de Espanha</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.park-is.com/\">PaRK International School Restelo</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.isbergamo.com\">International School of Europe Bergamo</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://www.internationalschoolofmilan.it\">International School of Europe Milan</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://isekiddyenglish.it\">International School of Europe Kiddy English</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.stlouisschool.com/early-years/colanna-campus\">St. Louis School Via Colonna</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.stlouisschool.com/early-years/caviglia-campus\">St. Louis School Via Caviglia</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.stlouisschool.com/high-school/pantano-campus\">St. Louis School Via Patano</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.internationalschoolofmodena.it/\">International School of Europe Modena</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://internationalschoolsgroup.it/school/monza/\">International School of Europe Monza</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.internationalschoolofsiena.it/\">International School of Europe Siena</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://internationalschoolsgroup.it/school/como/\">International School of Europe Como</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://stjohns.be/\">St. John's International School</a>\n\t\t\t\t<span>|</span>\n\t\t\t</div>\n\t\t\t<div tabindex=\"0\" class=\"inspried-content\"\n\t\t\t\t[@openClose]=\"isShowContent.isShowContentAfrica ? 'open' : 'closed'\">\n\t\t\t\t<a href=\"https://britishschoolbahrain.com\">British School of Bahrain</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://ballito.reddamhouse.com\">Reddam House Ballito</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://asb.reddamhouse.com\">Reddam House Atlantic Seaboard</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://constantia.reddamhouse.com\">Reddam House Constantia</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://durbanville.reddamhouse.com\">Reddam House Durbanville</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://somerset.reddamhouse.com\">Reddam House Somerset</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://umhlanga.reddamhouse.com\">Reddam House Umhlanga</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://helderfontein.reddamhouse.com\">Reddam House Helderfontein</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://bedfordview.reddamhouse.com\">Reddam House Bedfordview</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://waterfall.reddamhouse.com\">Reddam House Waterfall</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://bluehills.reddford.co.za/\">Reddford House Blue Hills</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://northcliff.reddford.co.za/\">Reddford House Northcliff</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://thehills.reddford.co.za/\">Reddford House The Hills</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://brookhouse.ac.ke/school/runda/\">Brookhouse School Runda</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://brookhouse.ac.ke/school/karen\">Brookhouse School Karen</a>\n\t\t\t\t<span>|</span>\n\t\t\t</div>\n\t\t\t<div tabindex=\"0\" class=\"inspried-content\"\n\t\t\t\t[@openClose]=\"isShowContent.isShowContentAsia ? 'open' : 'closed'\">\n\t\t\t\t<a href=\"http://reddamels.com.au/school/woollahra/\">Reddam ELS Woollahra</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://reddamels.com.au/school/lindfield/\">Reddam ELS Lindfield</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://reddamels.com.au/school/st-leonards/\">Reddam ELS St Leonards</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Strathallan*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Parnell College*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Sunderland School & College*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Penguins School ELS*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Tauranga*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Zig Zag Zoo ELS*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Australian International School K-6*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG Australian International School K-13*</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">Blue Valley School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">Colegio San Mateo</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.aisvietnam.com/\">ACG School Jakarta*</a>\n\t\t\t\t<span>|</span>\n\t\t\t</div>\n\t\t\t<div tabindex=\"0\" class=\"inspried-content\"\n\t\t\t\t[@openClose]=\"isShowContent.isShowContentLatin ? 'open' : 'closed'\">\n\t\t\t\t<a href=\"https://www.bluevalley.ed.cr/eng/\">Blue Valley School</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://csma.edu.co\">Colegio San Mateo </a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"http://cambridge.edu.pe\">Cambridge College Lima</a>\n\t\t\t\t<span>|</span>\n\t\t\t\t<a href=\"https://www.altair.edu.pe/\">Colegio Altair</a>\n\t\t\t\t<span>|</span>\n\t\t\t</div>\n\t\t\t<!--Start Inspried title -->\n\t\t\t<ul class=\"inspried-title\">\n\t\t\t\t<li tabindex=\"0\" class=\"aurope\" (click)=\"showContent(0)\"\n\t\t\t\t\t[style.color]=\"isShowContent.isShowContentEurope ? '#2F7EBB' : '#fff'\">\n\t\t\t\t\tEUROPE\n\t\t\t\t\t<div class=\"bubblewhite\"></div>\n\t\t\t\t\t<div class=\"bubbleblue\" *ngIf=\"isShowContent.isShowContentEurope\"></div>\n\t\t\t\t</li>\n\n\t\t\t\t<div class=\"inline\"> | </div>\n\n\t\t\t\t<li tabindex=\"0\" class=\"africa\" (click)=\"showContent(1)\"\n\t\t\t\t\t[style.color]=\"isShowContent.isShowContentAfrica ? '#2F7EBB' : '#fff'\">\n\t\t\t\t\tAFRICA & MIDDLE EAST\n\t\t\t\t\t<div class=\"bubblewhite\"></div>\n\t\t\t\t\t<div class=\"bubbleblue\" *ngIf=\"isShowContent.isShowContentAfrica\"></div>\n\t\t\t\t</li>\n\n\t\t\t\t<div class=\"inline\"> | </div>\n\n\t\t\t\t<li tabindex=\"0\" class=\"asia-pacific\" (click)=\"showContent(2)\"\n\t\t\t\t\t[style.color]=\"isShowContent.isShowContentAsia ? '#2F7EBB' : '#fff'\">\n\t\t\t\t\tASIA PACIFIC\n\t\t\t\t\t<div class=\"bubblewhite\"></div>\n\t\t\t\t\t<div class=\"bubbleblue\" *ngIf=\"isShowContent.isShowContentAsia\"></div>\n\n\t\t\t\t</li>\n\n\t\t\t\t<div class=\"inline\"> | </div>\n\n\t\t\t\t<li tabindex=\"0\" class=\"latin-america\" (click)=\"showContent(3)\"\n\t\t\t\t\t[style.color]=\"isShowContent.isShowContentLatin ? '#2F7EBB' : '#fff'\">\n\t\t\t\t\tLATIN AMERICA\n\t\t\t\t\t<div class=\"bubblewhite\"></div>\n\t\t\t\t\t<div class=\"bubbleblue\" *ngIf=\"isShowContent.isShowContentLatin\"></div>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<!--End Inspried title -->\n\t\t</div>\n\t\t<!--End Inspried content -->\n\t</div>\n</div>\n<!-- Inspried -->";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = ".inspired .member-inspried{z-index:1000;position:fixed;left:0;bottom:-3px;width:100%}.inspired .member-inspried:hover .inspried-content-wrap{transition-delay:0.5s;max-height:500px}.inspired .member-inspried .inspried-logo img{width:150px;height:34px}.inspired .member-inspried .inspried-content-wrap{transition:1.5s max-height linear;transition-delay:-0.8s;max-height:0px;overflow:hidden;width:100%;padding:0.55rem 0 0.2rem 0.55rem;background-color:#122147;margin-bottom:-1px}.inspired .member-inspried .inspried-content-wrap .inspried-content{font-size:.9em;display:block;background-color:#122147}.inspired .member-inspried .inspried-content-wrap .inspried-content span{color:#2F7EBB}.inspired .member-inspried .inspried-content-wrap .inspried-content a{color:#fff;font-size:14px}.inspired .member-inspried .inspried-content-wrap .inspried-content a:hover{text-decoration:underline}.inspired .member-inspried .inspried-content-wrap .inspried-title{width:100%;cursor:pointer;list-style:none;margin:5px 0 3px 0;padding:0px 0 30px 0;display:block;position:relative;z-index:20;background-color:#122147}.inspired .member-inspried .inspried-content-wrap .inspried-title li{position:relative;font-size:.9em;text-transform:uppercase;font-weight:700;float:left;outline:none}.inspired .member-inspried .inspried-content-wrap .inspried-title li:hover .bubblewhite{background:#fff;bottom:-25}.inspired .member-inspried .inspried-content-wrap .inspried-title li a{color:#fff}.inspired .member-inspried .inspried-content-wrap .inspried-title li .bubblewhite{position:absolute;left:50%;bottom:-40;transform:translate(-50%);padding:11.55px;width:12px;height:12px;background:#fff;border-radius:50%}.inspired .member-inspried .inspried-content-wrap .inspried-title li .bubbleblue{position:absolute;left:50%;bottom:-25;transform:translate(-50%);padding:12px;width:12px;height:12px;background:#2F7EBB;border-radius:50%;z-index:999}.inspired .member-inspried .inspried-content-wrap .inspried-title .inline{float:left;margin:0 10px;font-size:.9rem;float:left;color:#2F7EBB;vertical-align:middle}\n"

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var MenuService_1 = __webpack_require__(84);
	var UserService_1 = __webpack_require__(98);
	var SessionService_1 = __webpack_require__(99);
	var router_1 = __webpack_require__(39);
	var HolidayService_1 = __webpack_require__(100);
	var services_1 = __webpack_require__(73);
	var AdminService_1 = __webpack_require__(101);
	var MainMenuComponent = (function () {
	    function MainMenuComponent(menuService, router, holidayService, userService, sessionService, sessionStorageService, adminService) {
	        this.menuService = menuService;
	        this.router = router;
	        this.holidayService = holidayService;
	        this.userService = userService;
	        this.sessionService = sessionService;
	        this.sessionStorageService = sessionStorageService;
	        this.adminService = adminService;
	        this.menuStatusChanged = new Subject_1.Subject();
	        this.userMenuClassVisible = 'menu-list-visible';
	        this.devEnv = ['services.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn', 'conference.eca.dev.nascorp.vn'];
	        this.testEnv = ['services.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn', 'conference.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['services.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com', 'pcbs.aisvietnam.com'];
	    }
	    MainMenuComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.parent = new Object;
	        this.getSessionData();
	        this.hostName = window.location.hostname;
	        // Get main menu List
	        this.menuList = this.getMainMenuList();
	        //  Get sub menu list
	        this.subMenuList = this.getSubMenuList();
	        this.menuStatus = this.getMenuStatus();
	        // Subscription to catch the session changed to change the menu list content
	        this.subscription = this.userService.userDataChanged$.subscribe(function (user) {
	            _this.onSessionChanged(user);
	        });
	    };
	    MainMenuComponent.prototype.checkAccountIsAisParent = function () {
	        return this.sessionStorageService.getData('isAisParent');
	    };
	    MainMenuComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    /**
	     * Action that fired when the session change event is catched.
	     * Update the userData & the menuList.
	     */
	    MainMenuComponent.prototype.onSessionChanged = function (user) {
	        //TO DO: update menu content when session changed
	        this.userData = user;
	        // Get Menu List
	        this.menuList = this.getMainMenuList();
	        this.subMenuList = this.getSubMenuList();
	    };
	    MainMenuComponent.prototype.onMenuStatusChanged = function () {
	        this.menuStatus = this.getMenuStatus();
	    };
	    MainMenuComponent.prototype.getMenuStatus = function () {
	        if (document.URL === 'http://services.eca.dev.nascorp.vn/' ||
	            document.URL === 'http://services.local.eca.dev.nascorp.vn/' ||
	            document.URL === 'http://services.eca.test.nascorp.vn/' ||
	            document.URL === 'http://services.eca.uat.nascorp.vn/' ||
	            document.URL === 'https://services.aisvietnam.com/') {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * Return a module 's menu list content for the main menu.
	     * Return login main menu list if no user data is detected.
	     * @returns {Menu[]|[]} - module's menu list or empty list.
	     */
	    MainMenuComponent.prototype.getMainMenuList = function () {
	        var menuList = [];
	        if (!this.userData && (this.hostName === "holidayschool.aisvietnam.com"
	            || this.hostName === "holiday.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.local.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.eca.test.nascorp.vn"
	            || this.hostName === "holidayschool.eca.uat.nascorp.vn")) {
	            menuList = this.menuService.getMenuList('hol-login');
	        }
	        else if (!this.userData) {
	            menuList = this.menuService.getMenuList('login-main');
	        }
	        else {
	            menuList = this.menuService.getMenuList(this.module + '-main');
	        }
	        return menuList;
	    };
	    /**
	     * Return a module 's SUB menu list content for the main menu.
	     * Return login main menu list if no user data is detected.
	     * @returns {Menu[]|[]} - module's menu list or empty list.
	     */
	    MainMenuComponent.prototype.getSubMenuList = function () {
	        return this.menuService.getMenuList(this.module + '-sub');
	    };
	    MainMenuComponent.prototype.toLogOut = function () {
	        this.userData = this.userService.getUserSessionData();
	        this.deleteSession();
	    };
	    /**
	 * Delete user session data.
	 */
	    MainMenuComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.userService.clearUserSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.userService.userDataChanged(null);
	            // Redirect to desired URL                    
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	            }
	        });
	    };
	    MainMenuComponent.prototype.getSessionData = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userData = user;
	            if (_this.userData.role !== 'system' && _this.userData.role !== 'manager') {
	                _this.getParent();
	            }
	        });
	    };
	    MainMenuComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL
	        if (this.userData.role === 'parent' || this.parent.type === 'ais') {
	            if (this.devEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn/parents';
	            }
	            else if (this.testEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn/parents';
	            }
	            else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn/parents';
	            }
	            else if (this.procEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com/parents';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn/parents';
	            }
	        }
	        // Redirect to desired URL
	        if (this.userData.role === 'hol-parent' || this.parent.type === 'other') {
	            if (this.devEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn/other-parents';
	            }
	            else if (this.testEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn/other-parents';
	            }
	            else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn/other-parents';
	            }
	            else if (this.procEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com/other-parents';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn/other-parents';
	            }
	        }
	        if (!this.userData && !this.parent) {
	            if (this.devEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn';
	            }
	            else if (this.testEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn';
	            }
	            else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn';
	            }
	            else if (this.procEnv.indexOf(this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	            }
	        }
	    };
	    MainMenuComponent.prototype.toRegister = function () {
	        if (this.hostName === "holidayschool.aisvietnam.com"
	            || this.hostName === "holiday.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.local.eca.dev.nascorp.vn") {
	            this.router.navigateByUrl('/hol-register');
	        }
	        else {
	            this.router.navigate(['/register']);
	        }
	    };
	    MainMenuComponent.prototype.toChangePassword = function () {
	        if (this.hostName === "holidayschool.aisvietnam.com"
	            || this.hostName === "holiday.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.local.eca.dev.nascorp.vn") {
	            this.router.navigateByUrl('/hol-change-password');
	        }
	        else {
	            this.router.navigate(['/change-password']);
	        }
	    };
	    MainMenuComponent.prototype.menuStatusDataChanged = function (menu) {
	        this.menuStatusChanged.next(menu);
	    };
	    MainMenuComponent.prototype.getParent = function () {
	        var _this = this;
	        this.holidayService.getParent()
	            .subscribe(function (parent) {
	            _this.parent = parent;
	            if (_this.parent.status === "fill-info") {
	                _this.router.navigate(['/profile/add-parent']);
	            }
	            else if (_this.parent.status == "full") {
	                _this.router.navigate(['/booking/students']);
	            }
	            else {
	                _this.router.navigate(['/add-student']);
	            }
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    MainMenuComponent.prototype.toProfile = function () {
	        if (this.hostName === "holidayschool.aisvietnam.com"
	            || this.hostName === "holiday.eca.dev.nascorp.vn"
	            || this.hostName === "holiday.local.eca.dev.nascorp.vn") {
	            this.router.navigateByUrl('/profile/edit-parent');
	        }
	        else {
	            this.router.navigate(['/profile/edit-parent']);
	        }
	    };
	    return MainMenuComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], MainMenuComponent.prototype, "module", void 0);
	MainMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'main-menu',
	        template: __webpack_require__(102),
	        styles: [__webpack_require__(104)],
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService,
	        router_1.Router,
	        HolidayService_1.HolidayService,
	        UserService_1.UserService,
	        SessionService_1.SessionService,
	        services_1.SessionStorageService,
	        AdminService_1.AdminService])
	], MainMenuComponent);
	exports.MainMenuComponent = MainMenuComponent;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var services_1 = __webpack_require__(73);
	var UserService = (function () {
	    function UserService(sessionStorageService) {
	        this.sessionStorageService = sessionStorageService;
	        // Observable User source
	        this.userDataChangedSource = new Subject_1.Subject();
	        // Observable User streams
	        this.userDataChanged$ = this.userDataChangedSource.asObservable();
	    }
	    UserService.prototype.getUserSessionData = function () {
	        return this.sessionStorageService.getData('eca-user');
	    };
	    UserService.prototype.setUserSessionData = function (user) {
	        return this.sessionStorageService.setData('eca-user', user);
	    };
	    UserService.prototype.clearUserSessionData = function () {
	        return this.sessionStorageService.removeData('eca-user');
	    };
	    UserService.prototype.userDataChanged = function (user) {
	        this.userDataChangedSource.next(user);
	    };
	    return UserService;
	}());
	UserService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SessionStorageService])
	], UserService);
	exports.UserService = UserService;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var services_1 = __webpack_require__(73);
	var SessionService = (function () {
	    function SessionService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.sessionUrl = '/session';
	        this.cafeteriaUrl = '/caterer-service/';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get Session from API
	     * @params: none
	     * @return: status 200 - User observable object if session is provied succesfully.
	     *          status 401 - Unauthorized if user credentials are invalid.
	     * */
	    SessionService.prototype.getSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get Session from API
	     * @params: User Observable Object
	     * @return: status 200 - User observable object if session is created.
	     *          status 401 - Unauthorized if no session is found.
	     * */
	    SessionService.prototype.postSession = function (credential) {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        var body = JSON.stringify({
	            'role': credential.role,
	            'email': credential.email,
	            'password': credential.password
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    SessionService.prototype.deleteSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        return this.apiService.delete(requestUrl);
	    };
	    SessionService.prototype.getCafeteriaUrl = function () {
	        var requestUrl = this.apiUrl + this.cafeteriaUrl + 'daisyLink';
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    SessionService.prototype.getSessionDaisy = function () {
	        var requestUrl = this.apiUrl + this.cafeteriaUrl + 'getTokenByCookie';
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    return SessionService;
	}());
	SessionService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], SessionService);
	exports.SessionService = SessionService;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(73);
	var HolidayService = (function () {
	    function HolidayService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        this.courseUrl = '/hol/course';
	        this.courseClassUrl = '/hol/class/';
	        this.courseStudentUrl = '/hol/student/';
	        this.parentUrl = '/hol/parent';
	        this.convertParentUrl = '/hol/parent/convert';
	        this.parentPassword = '/hol/parent/password';
	        this.weekUrl = '/hol/week';
	        this.excursionUrl = '/hol/excursion';
	        this.questionnarie = "/hol/questionnaire";
	        this.parentEmail = '/hol/parent/email';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    HolidayService.prototype.createCourse = function (courseItem) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        // Post content
	        var body = JSON.stringify(courseItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.createCourseClass = function (courseClassItem) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        // Post content
	        var body = JSON.stringify(courseClassItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.getCourseList = function (filter) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getCourseDetail = function (courseId) {
	        var requestUrl = this.apiUrl + this.courseUrl + '?id=' + courseId;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getFullCourseList = function () {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.editCourse = function (courseItem) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        var body = JSON.stringify({
	            id: courseItem.id,
	            name: courseItem.name,
	            type: courseItem.type,
	            school_year: courseItem.school_year,
	            start_date: courseItem.start_date,
	            end_date: courseItem.end_date,
	            description: courseItem.description,
	            status: courseItem.status
	        });
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.updateParent = function (nonAisParent) {
	        var requestUrl = this.apiUrl + this.parentUrl;
	        var body = JSON.stringify(nonAisParent);
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.getParent = function (filter) {
	        if (filter === void 0) { filter = []; }
	        var requestUrl = this.apiUrl + this.parentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.changeParentPassword = function (query) {
	        var requestUrl = this.apiUrl + this.parentPassword;
	        var body = JSON.stringify(query);
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.changeParentEmail = function (query) {
	        var requestUrl = this.apiUrl + this.parentEmail;
	        var body = JSON.stringify(query);
	        return this.apiService.put(requestUrl, body);
	    };
	    HolidayService.prototype.convertParent = function () {
	        var requestUrl = this.apiUrl + this.convertParentUrl;
	        var body = JSON.stringify({});
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.getCourseClassList = function (filter) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getClassDetail = function (classId) {
	        var requestUrl = this.apiUrl + this.courseClassUrl + '?id=' + classId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getFullCourseClassList = function () {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.editClass = function (classItem) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        var body = JSON.stringify({
	            id: classItem.id,
	            thumbnail_id: classItem.thumbnail_id,
	            name: classItem.name,
	            room: classItem.room,
	            campus_id: classItem.campus_id,
	            teacher: classItem.teacher,
	            max_number: classItem.max_number,
	            suitable_from: classItem.suitable_from,
	            suitable_to: classItem.suitable_to,
	            total_cost: +classItem.total_cost,
	            cost_per_week: classItem.cost_per_week,
	            activities: classItem.activities,
	            status: classItem.status,
	            prices: classItem.prices
	        });
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Get week
	    HolidayService.prototype.getWeekService = function () {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        return this.apiService.get(requestUrl);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Add week
	    HolidayService.prototype.addWeekService = function (weeks) {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        var body = JSON.stringify(weeks);
	        return this.apiService.post(requestUrl, body);
	    };
	    //Edit week
	    HolidayService.prototype.editWeekService = function (weeks) {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        var body = JSON.stringify(weeks);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Get excursion
	    HolidayService.prototype.getExcursionService = function (filter) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Add excursion
	    HolidayService.prototype.addExcursionService = function (excursion) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var body = JSON.stringify(excursion);
	        return this.apiService.post(requestUrl, body);
	    };
	    //Edit week
	    HolidayService.prototype.editExcursionService = function (excursion) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var body = JSON.stringify(excursion);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Remove student in class
	    HolidayService.prototype.removeStudentInClass = function (studentId, classId) {
	        var requestUrl = this.apiUrl + this.courseStudentUrl + studentId + '/class/' + classId;
	        var body = {
	            "holStudentId": studentId,
	            "holClassId": classId
	        };
	        return this.apiService.deletePost(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Transfer waiting student in class
	    HolidayService.prototype.transferStudentInClass = function (studentId, classId, status) {
	        var requestUrl = this.apiUrl + this.courseClassUrl + classId + '/student/' + studentId;
	        var body = {
	            "holStudentId": studentId,
	            "holClassId": classId,
	            "status": status
	        };
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.getParentById = function (id) {
	        var requestUrl = this.apiUrl + this.parentUrl + '/' + id;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getQuestionnarie = function () {
	        var requestUrl = this.apiUrl + this.questionnarie;
	        return this.apiService.get(requestUrl);
	    };
	    ;
	    HolidayService.prototype.getQuestionnarieById = function (id) {
	        var requestUrl = this.apiUrl + this.questionnarie + '/' + id;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.upsertQuestionnarie = function (question) {
	        var body = JSON.stringify(question);
	        var requestUrl = this.apiUrl + this.questionnarie;
	        return this.apiService.put(requestUrl, body);
	    };
	    ;
	    return HolidayService;
	}());
	HolidayService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], HolidayService);
	exports.HolidayService = HolidayService;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var services_1 = __webpack_require__(73);
	var AdminService = (function () {
	    function AdminService(sessionStorageService) {
	        this.sessionStorageService = sessionStorageService;
	        this.adminDataChangedSource = new Subject_1.Subject();
	        this.logger = new Subject_1.Subject();
	        // Observable Admin streams
	        this.adminDataChanged$ = this.adminDataChangedSource.asObservable();
	    }
	    AdminService.prototype.getAdminSessionData = function () {
	        return this.sessionStorageService.getData('asa-admin');
	    };
	    AdminService.prototype.getInterSesstion = function () {
	        return this.sessionStorageService.getData('curId');
	    };
	    AdminService.prototype.setAdminSessionData = function (admin) {
	        return this.sessionStorageService.setData('asa-admin', admin);
	    };
	    AdminService.prototype.clearAdminSessionData = function () {
	        return this.sessionStorageService.removeData('asa-admin');
	    };
	    AdminService.prototype.clearInterSession = function () {
	        return this.sessionStorageService.removeData('curId');
	    };
	    AdminService.prototype.adminDataChanged = function (admin) {
	        return this.adminDataChangedSource.next(admin);
	    };
	    return AdminService;
	}());
	AdminService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SessionStorageService])
	], AdminService);
	exports.AdminService = AdminService;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-main-menu\">\n\t<!-- Hamburger Menu -->\n\t<div class=\"hamburger-menu\">\n\t\t<a href=\"#\">\n\t\t\t<i class=\"material-icons\">menu</i>\n\t\t</a>\n\t</div>\n\t<div class=\"container\">\n\t\t<div class=\"top-bar\">\n\t\t\t<!--Top bar left-->\n\t\t\t<div class=\"top-bar-left\">\n\t\t\t\t<!-- Logo -->\n\t\t\t\t<div class=\"logo\">\n\t\t\t\t\t<a (click)=\"toHomePage()\"><img src=\"" + __webpack_require__(103) + "\"></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--End of Top bar left-->\n\n\t\t\t<!--Top bar right-->\n\t\t\t<div class=\"top-bar-right\">\n\t\t\t\t<!-- Menu Items -->\n\t\t\t\t<div class=\"main-right-menu\">\n\t\t\t\t\t<ul class=\"menu\" *ngIf=\"menuStatus\">\n\t\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t\t<li *ngFor=\"let menu of menuList;\">\n\t\t\t\t\t\t\t<div *ngIf=\"!userData\">\n\t\t\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<!-- Show user menu item if have user data from session -->\n\t\t\t\t\t\t<li *ngIf=\"userData\" class=\"user-profile-menu\" [menuHover]=\"userMenuClassVisible\">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<a>\n\t\t\t\t\t\t\t\t\t<span>Hi, {{userData.name.split('@')[0]}}</span>\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">keyboard_arrow_down</i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<ul class=\"\">\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toChangePassword()\">Change Password</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li *ngIf=\"!checkAccountIsAisParent()\">\n\t\t\t\t\t\t\t\t\t<a (click)=\"toProfile()\">Profile</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toLogOut()\">Logout</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t\t<!--New sub menu for module-->\n\t\t\t\t<ul class=\"sub-menu\" *ngIf=\"userData\" >\n\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t<li *ngFor=\"let menu of subMenuList\">\n\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<!--End of sub menu-->\n\t\t\t</div>\n\t\t\t<!--End of top bar right-->\n\t\t</div>\n\t\t<!--End of top bar-->\n\t</div>\n</div>";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/logo.d5018a0115cf3749750fa4da0ec46459.png";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = "#app-main-menu{background-color:#043d7a;position:relative;padding:0rem 5%}#app-main-menu .hamburger-menu{display:none}#app-main-menu .top-bar{background:transparent}#app-main-menu .top-bar .top-bar-left{flex:0.5 0.5 0px}#app-main-menu .top-bar .top-bar-right{padding-top:1rem}#app-main-menu .logo>a{display:inline-block}#app-main-menu .logo>a img{height:100px}#app-main-menu .sub-menu{float:right;background:transparent;font-size:0.9rem}#app-main-menu .sub-menu li{list-style:none;display:inline-block;text-transform:uppercase}#app-main-menu .sub-menu li a{display:block;color:#fff;padding:0.5rem;margin:0 0.3rem}#app-main-menu .sub-menu li a.active{border-bottom:solid 2px #ffae00}#app-main-menu .main-right-menu{float:right}#app-main-menu .main-right-menu .menu{background-color:#043d7a}#app-main-menu .main-right-menu .menu>li>div>a{padding:0.5rem 1rem;border-radius:0.2rem;margin-left:1rem;min-width:6.25rem;border:1px solid #7b95b0;color:#fff;text-align:center}#app-main-menu .main-right-menu .menu>li>div>a:hover,#app-main-menu .main-right-menu .menu>li>div>a.active{background-color:#faa635;border:1px solid #faa635;color:#043d7a}#app-main-menu .main-right-menu .menu>li>div>a>i{margin:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu{position:relative}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a{margin-bottom:0.5rem;line-height:23px;display:inline-block;padding-top:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a span{display:inline-block}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a i{display:inline-block;position:relative;top:6px}#app-main-menu .main-right-menu .menu>li.user-profile-menu>ul{list-style:none;border-radius:0.2rem;position:absolute;z-index:2;right:0;width:130%;display:none}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul{display:block;box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a{display:block;padding:0.4rem 1rem;border-radius:0.2rem}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a:hover{background-color:#faa635;color:#043d7a}@media only screen and (max-width: 40em){#app-main-menu{height:auto;min-height:4rem}#app-main-menu .hamburger-menu{position:absolute;display:none;left:0;top:50%;transform:translateY(-50%);-ms-transform:translateY(-50%);-webkit-transform:translateY(-50%)}#app-main-menu .hamburger-menu>a{color:#fff;font-size:2rem}#app-main-menu .hamburger-menu>a>i{padding:1rem}#app-main-menu .logo{padding:0.4rem;margin:0 auto}#app-main-menu .logo>a{margin:0 auto;min-height:3rem}#app-main-menu .main-right-menu{display:none}#app-main-menu .top-bar-left{flex:none !important}}\n"

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(84);
	var TopMenuComponent = (function () {
	    function TopMenuComponent(menuService) {
	        this.menuService = menuService;
	    }
	    TopMenuComponent.prototype.ngOnInit = function () {
	        /** TO DO
	         * Get current language from cookie/session
	         * If no language data from it, set default language as English
	         */
	        this.currentLang = 'en';
	        // Get Top Menu List
	        this.menuList = this.menuService.getMenuList('top');
	        // Get Social Connect Menu List
	        this.socialMenuList = this.menuService.getMenuList('social-top');
	    };
	    return TopMenuComponent;
	}());
	TopMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'top-menu',
	        template: __webpack_require__(106),
	        styles: [__webpack_require__(107)],
	        providers: [
	            MenuService_1.MenuService
	        ]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService])
	], TopMenuComponent);
	exports.TopMenuComponent = TopMenuComponent;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"app-top-menu\" class=\"top-bar\">\n    <!-- Left Menu List -->\n\t<div class=\"top-bar-left\" *ngIf=\"currentLang=='en'\">\n\t\t<ul class=\"menu\">\n\t\t\t<li *ngFor=\"let menu of menuList\">\n\t\t\t\t<a href=\"{{menu.url}}\" target=\"{{menu.target}}\">{{menu.label}}</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<!-- Right Menu List -->\n\t<div class=\"top-bar-right\">\n\t\t<ul class=\"menu\">\n\t\t\t<li *ngFor=\"let sMenu of socialMenuList\">\n\t\t\t\t<a href=\"{{sMenu.url}}\" target=\"{{sMenu.target}}\">\n\t\t\t\t<i class=\"fa fa-{{sMenu.id}}\"></i></a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports = "#app-top-menu{background-color:#064180;padding:0rem 4rem}#app-top-menu .menu{background-color:#064180}#app-top-menu .menu>li>a{padding:0.5rem;color:#fff}#app-top-menu .menu>li>a:hover{color:#faa635}#app-top-menu .top-bar-left .menu>li>a{padding:0.6rem 0.3rem;font-size:0.8rem}#app-top-menu .top-bar-right{flex:0 0 0px !important}@media only screen and (max-width: 40em){#app-top-menu{padding:0;overflow-x:hidden}#app-top-menu .menu{height:0}}\n"

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuHoverDirective = (function () {
	    function MenuHoverDirective(el, renderer) {
	        this.el = el;
	        this.renderer = renderer;
	    }
	    MenuHoverDirective.prototype.onMouseEnter = function () {
	        this.setClass(this.className, true);
	    };
	    MenuHoverDirective.prototype.onMouseLeave = function () {
	        this.setClass(this.className, false);
	    };
	    MenuHoverDirective.prototype.setClass = function (className, isAdd) {
	        this.renderer.setElementClass(this.el.nativeElement, className, isAdd);
	    };
	    return MenuHoverDirective;
	}());
	__decorate([
	    core_1.Input('menuHover'),
	    __metadata("design:type", String)
	], MenuHoverDirective.prototype, "className", void 0);
	__decorate([
	    core_1.HostListener('mouseenter'),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", []),
	    __metadata("design:returntype", void 0)
	], MenuHoverDirective.prototype, "onMouseEnter", null);
	__decorate([
	    core_1.HostListener('mouseleave'),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", []),
	    __metadata("design:returntype", void 0)
	], MenuHoverDirective.prototype, "onMouseLeave", null);
	MenuHoverDirective = __decorate([
	    core_1.Directive({
	        selector: '[menuHover]'
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
	], MenuHoverDirective);
	exports.MenuHoverDirective = MenuHoverDirective;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(39);
	var AdminService_1 = __webpack_require__(101);
	var SessionService_1 = __webpack_require__(110);
	var AdminHeaderComponent = (function () {
	    function AdminHeaderComponent(adminService, sessionService, router) {
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	        // For logout navigate
	        this.devEnv = ['auth.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn', 'conference.eca.dev.nascorp.vn'];
	        this.testEnv = ['auth.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn', 'conference.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['auth.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com', 'pcbs.aisvietnam.com'];
	    }
	    AdminHeaderComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        this.hostName = window.location.hostname;
	        this.headerName = this.getHeaderName(this.module);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        // Get Admin session
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    AdminHeaderComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    AdminHeaderComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	        this.sidebarStatus = this.getSidebarStatus();
	    };
	    AdminHeaderComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	        });
	    };
	    AdminHeaderComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL                    
	        if (this.devEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.dev.nascorp.vn';
	        }
	        else if (this.testEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.test.nascorp.vn';
	        }
	        else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.uat.nascorp.vn';
	        }
	        else if (this.procEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'https://services.aisvietnam.com';
	        }
	        else {
	            return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	        }
	    };
	    // Detect sidebar vibibility
	    AdminHeaderComponent.prototype.getSidebarStatus = function () {
	        return !this.adminData ? false : true;
	    };
	    AdminHeaderComponent.prototype.getHeaderName = function (moduleName) {
	        var headerName = "";
	        switch (this.module) {
	            case "camp":
	                headerName = "Camp Programmes Management";
	                break;
	            case "asa":
	                headerName = "Extra-Curricular Activities (ECAs) Management";
	                break;
	            case "bus":
	                headerName = "Bus Management";
	                break;
	            case "reen":
	                headerName = "Re-enrolment";
	                break;
	            case "conference":
	                headerName = "Conference Booking System";
	                break;
	            default:
	                break;
	        }
	        return headerName;
	    };
	    // Log our function
	    AdminHeaderComponent.prototype.deleteSession = function () {
	        var _this = this;
	        // In case system login and booking for parent. Then, logout and login again with role parent to booking. We need to remove sessionStorage 
	        if (this.module === 'conference') {
	            window.sessionStorage.removeItem('info-parent-booking');
	            window.sessionStorage.removeItem('interview-description');
	        }
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.dev.nascorp.vn/logout';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.test.nascorp.vn/logout';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.uat.nascorp.vn/logout';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://auth.aisvietnam.com/logout';
	            }
	            else {
	                return window.location.href = 'http://auth.local.eca.dev.nascorp.vn/logout';
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    return AdminHeaderComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminHeaderComponent.prototype, "module", void 0);
	AdminHeaderComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-header',
	        template: __webpack_require__(111),
	        styles: [__webpack_require__(112)]
	    }),
	    __metadata("design:paramtypes", [AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminHeaderComponent);
	exports.AdminHeaderComponent = AdminHeaderComponent;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var services_1 = __webpack_require__(73);
	var SessionService = (function () {
	    function SessionService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.sessionUrl = '/session';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    SessionService.prototype.getSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    SessionService.prototype.postAdminSession = function (adminCredential) {
	        var requestUrl = '/ldap?' + 'username=' + adminCredential.username + '&password=' + adminCredential.password;
	        var body = JSON.stringify({
	            'role': adminCredential.role,
	            'username': adminCredential.username,
	            'password': adminCredential.password
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    SessionService.prototype.deleteAdminSession = function () {
	        // const requestUrl = 'http://auth.eca.dev.nascorp.vn/logout';
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        return this.apiService.delete(requestUrl);
	    };
	    return SessionService;
	}());
	SessionService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], SessionService);
	exports.SessionService = SessionService;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"header row\">\n    <h1 class=\"large-2\"><img src=\"" + __webpack_require__(103) + "\" (click)=\"toHomePage()\"></h1>\n    <div class=\"header-info large-10\">\n        <div class=\"component-name\">\n            <h3>{{headerName}}</h3>\n        </div>\n        <ul *ngIf=\"sidebarStatus\">\n            <li><a (click)=\"deleteSession()\">Logout</a></li>\n        </ul>\n    </div>";

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports = ".header.row{height:78px;border-bottom:1px solid #e1e4e9;position:fixed;left:0;top:0;width:100%;z-index:5;max-width:100%}.header.row h1{background:#043d7a;display:inline-block;text-align:center;margin-bottom:0;padding:0 1.3125rem}.header.row h1 img{width:160px;cursor:pointer}.header.row .header-info{background:#0b5db5;padding:0 2rem;overflow:hidden;width:calc(100% - 160px - 1.3125rem * 2)}.header.row .header-info .component-name{float:left}.header.row .header-info .component-name h3{font-size:0.875rem;color:#fff;line-height:78px;margin-bottom:0;display:inline-block}.header.row .header-info ul{float:right;margin:0;font-size:0.875rem;line-height:77px;list-style:none}.header.row .header-info ul li a{color:#fff}\n"

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(39);
	var AdminService_1 = __webpack_require__(101);
	var SessionService_1 = __webpack_require__(110);
	var AdminHeaderAuthComponent = (function () {
	    function AdminHeaderAuthComponent(adminService, sessionService, router) {
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	        // For logout navigate
	        this.devEnv = ['auth.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn', 'conference.eca.dev.nascorp.vn'];
	        this.testEnv = ['auth.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn', 'conference.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['auth.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com', 'pcbs.aisvietnam.com'];
	    }
	    AdminHeaderAuthComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        this.hostName = window.location.hostname;
	        this.headerName = this.getHeaderName(this.module);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        // Get Admin session
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    AdminHeaderAuthComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    AdminHeaderAuthComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	        this.sidebarStatus = this.getSidebarStatus();
	    };
	    AdminHeaderAuthComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	        });
	    };
	    AdminHeaderAuthComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL                    
	        if (this.devEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.dev.nascorp.vn';
	        }
	        else if (this.testEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.test.nascorp.vn';
	        }
	        else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'http://services.eca.uat.nascorp.vn';
	        }
	        else if (this.procEnv.indexOf(this.hostName) !== -1) {
	            return window.location.href = 'https://services.aisvietnam.com';
	        }
	        else {
	            return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	        }
	    };
	    // Detect sidebar vibibility
	    AdminHeaderAuthComponent.prototype.getSidebarStatus = function () {
	        return !this.adminData ? false : true;
	    };
	    AdminHeaderAuthComponent.prototype.getHeaderName = function (moduleName) {
	        var headerName = "";
	        switch (this.module) {
	            case "camp":
	                headerName = "Camp Programmes Management";
	                break;
	            case "asa":
	                headerName = "Extra-Curricular Activities (ECAs) Management";
	                break;
	            case "bus":
	                headerName = "Bus Management";
	                break;
	            case "reen":
	                headerName = "Re-enrolment";
	                break;
	            case "conference":
	                headerName = "Conference Booking System";
	                break;
	            default:
	                break;
	        }
	        return headerName;
	    };
	    // Log our function
	    AdminHeaderAuthComponent.prototype.deleteSession = function () {
	        var _this = this;
	        // In case system login and booking for parent. Then, logout and login again with role parent to booking. We need to remove sessionStorage 
	        if (this.module === 'conference') {
	            window.sessionStorage.removeItem('info-parent-booking');
	            window.sessionStorage.removeItem('interview-description');
	        }
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.dev.nascorp.vn/logout';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.test.nascorp.vn/logout';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.eca.uat.nascorp.vn/logout';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://auth.aisvietnam.com/logout';
	            }
	            else {
	                return window.location.href = 'http://auth.local.eca.dev.nascorp.vn/logout';
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    return AdminHeaderAuthComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminHeaderAuthComponent.prototype, "module", void 0);
	AdminHeaderAuthComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-header-auth',
	        template: __webpack_require__(114),
	        styles: [__webpack_require__(115)]
	    }),
	    __metadata("design:paramtypes", [AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminHeaderAuthComponent);
	exports.AdminHeaderAuthComponent = AdminHeaderAuthComponent;


/***/ }),
/* 114 */
102,
/* 115 */
104,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(39);
	var MenuService_1 = __webpack_require__(84);
	var AdminService_1 = __webpack_require__(101);
	var SessionService_1 = __webpack_require__(110);
	var AdminSidebarComponent = (function () {
	    function AdminSidebarComponent(menuService, adminService, sessionService, router) {
	        this.menuService = menuService;
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	    }
	    AdminSidebarComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        // Get Sidebar menu list
	        var sidebarName = this.getSidebarName(this.module);
	        this.sidebar = this.menuService.getMenuList(sidebarName);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	    };
	    AdminSidebarComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    /**
	     * Action that fired when the session change event is catched.
	     * Update the adminData & the menuList.
	     */
	    AdminSidebarComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	    };
	    AdminSidebarComponent.prototype.getSidebarStatus = function () {
	        if (!this.adminData) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    AdminSidebarComponent.prototype.getSidebarName = function (moduleName) {
	        var sidebarName = '';
	        switch (moduleName) {
	            case 'camp':
	                sidebarName = 'camp-admin-sidebar';
	                break;
	            case 'asa':
	                sidebarName = 'asa-admin-sidebar';
	                break;
	            case 'bus':
	                sidebarName = 'bus-admin-sidebar';
	                break;
	            case 'holiday':
	                sidebarName = 'holiday-admin-sidebar';
	                break;
	            case 'reen':
	                sidebarName = 'reen-admin-sidebar';
	                break;
	            case 'conference':
	                sidebarName = 'conference-admin-sidebar';
	                break;
	            default:
	                break;
	        }
	        return sidebarName;
	    };
	    // Check user role to show/hide option
	    AdminSidebarComponent.prototype.accessible = function (role, id) {
	        if (!role.length) {
	            return true;
	        }
	        //check exists curId => show/hide interview.
	        if (this.module == 'conference') {
	            if (this.adminData.pcbsRole == 'system') {
	                var curId = window.sessionStorage.getItem('curId') || '0';
	                var showInterviews = (id === 'interviews') == (curId === '0');
	                var hasPCBSRole = role.indexOf(this.adminData.pcbsRole) !== -1;
	                return hasPCBSRole && showInterviews;
	            }
	            else if (this.adminData.pcbsRole == 'teacher') {
	                return role.indexOf(this.adminData.pcbsRole) !== -1;
	                ;
	            }
	        }
	        return role.indexOf(this.adminData.role) !== -1 ? true : false;
	    };
	    AdminSidebarComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession().subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = '';
	            _this.messageType = 'alert';
	        });
	    };
	    AdminSidebarComponent.prototype.showLinkBackInt = function () {
	        var sessionUser = this.adminService.getAdminSessionData();
	        return !(window.sessionStorage.getItem('curId') && this.module == 'conference' && sessionUser.pcbsRole == 'system');
	    };
	    AdminSidebarComponent.prototype.clearInterSession = function () {
	        window.sessionStorage.removeItem('curId');
	        this.router.navigate(['interviews']);
	    };
	    return AdminSidebarComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminSidebarComponent.prototype, "module", void 0);
	AdminSidebarComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-sidebar',
	        template: __webpack_require__(117),
	        styles: [__webpack_require__(118)]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService,
	        AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminSidebarComponent);
	exports.AdminSidebarComponent = AdminSidebarComponent;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sidebar\" *ngIf=\"sidebarStatus\">\n    <ul>\n        <li *ngFor=\"let item of sidebar\" [hidden]=\"!accessible(item.role, item.id)\">\n            <a routerLink=\"{{item.url}}\" routerLinkActive=\"active\">\n                <span>{{item.label}}</span>\n                <i class=\"material-icons\">{{item.icon}}</i>\n            </a>\n        </li>\n    </ul>\n    <div class=\"linkInt\">\n        <a (click)=\"clearInterSession()\" [hidden]=\"showLinkBackInt()\" >\n            <tr>\n                <td class=\"material-icons\">reply</td>\n                <td> Go back interviews</td>\n            </tr>\n        </a>\n    </div>\n</div>";

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports = ".sidebar{background:#fff;min-height:100%;width:100%;border-right:1px solid #e1e4e9;overflow:auto;z-index:1}.sidebar ul{list-style:none;margin-left:0}.sidebar ul li{font-size:0.875rem;font-weight:600}.sidebar ul li a{color:#6e6e6e;display:block;overflow:hidden;padding:1.375rem}.sidebar ul li a span{display:inline-block;vertical-align:middle}.sidebar ul li a i{float:right}.sidebar ul li .active{background:#e6e6e6}.linkInt{position:fixed;bottom:60px;text-align:center;z-index:100;left:20px;font-size:0.91rem;font-weight:600;margin:0 auto}.linkInt a:hover,.linkInt a:focus{color:rgba(255,0,0,0.8);text-decoration:none;cursor:pointer;text-decoration:underline}\n"

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(110));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(121));
	__export(__webpack_require__(101));
	__export(__webpack_require__(110));
	__export(__webpack_require__(128));
	__export(__webpack_require__(123));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(24);
	var LoginComponent_1 = __webpack_require__(122);
	var LogoutComponent_1 = __webpack_require__(126);
	var AdminRouting_1 = __webpack_require__(127);
	var AdminService_1 = __webpack_require__(101);
	var SessionService_1 = __webpack_require__(110);
	var AdminModule = (function () {
	    function AdminModule() {
	    }
	    return AdminModule;
	}());
	AdminModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            shared_1.SharedModule,
	            AdminRouting_1.adminRouting,
	        ],
	        declarations: [
	            LoginComponent_1.LoginComponent,
	            LogoutComponent_1.LogoutComponent
	        ],
	        providers: [
	            AdminService_1.AdminService,
	            SessionService_1.SessionService,
	        ],
	        exports: [
	            LogoutComponent_1.LogoutComponent
	        ]
	    })
	], AdminModule);
	exports.AdminModule = AdminModule;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(39);
	// Services
	var SessionService_1 = __webpack_require__(110);
	var AdminService_1 = __webpack_require__(101);
	var AdminCredential_1 = __webpack_require__(123);
	var LoginComponent = (function () {
	    function LoginComponent(sessionService, adminService, router) {
	        this.sessionService = sessionService;
	        this.adminService = adminService;
	        this.router = router;
	        this.formSubmitted = false;
	        this.adminCredential = new AdminCredential_1.AdminCredential('', '', '');
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        this.deleteSession();
	        this.redirectUrl = '/navigate';
	        this.hostName = window.location.hostname;
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	    };
	    ;
	    LoginComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post admin login data to create session
	        this.postSession(this.adminCredential);
	    };
	    LoginComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            // Set admin session data
	            _this.adminService.setAdminSessionData(admin);
	            // Fire admin session data changed event
	            _this.adminService.adminDataChanged(admin);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update admin Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - admin credential input
	     * @return none
	     */
	    LoginComponent.prototype.postSession = function (adminCredential) {
	        var _this = this;
	        this.sessionService.postAdminSession(adminCredential)
	            .subscribe(function (admin) {
	            _this.adminService.setAdminSessionData(admin);
	            _this.adminService.adminDataChanged(admin);
	            // Redirect to nagigate center
	            _this.redirect('/navigate');
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid user name or password.";
	            _this.messageType = "alert";
	        });
	    };
	    // Redirect to desired url
	    LoginComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    LoginComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            _this.adminService.adminDataChanged(null);
	        });
	    };
	    return LoginComponent;
	}());
	LoginComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-login',
	        template: __webpack_require__(124),
	        styles: [__webpack_require__(125)]
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        AdminService_1.AdminService,
	        router_1.Router])
	], LoginComponent);
	exports.LoginComponent = LoginComponent;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AdminCredential = (function () {
	    function AdminCredential(role, username, password) {
	        this.role = role;
	        this.username = username;
	        this.password = password;
	    }
	    return AdminCredential;
	}());
	exports.AdminCredential = AdminCredential;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Login to your account</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- User name Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"username\">User name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your user name\" id=\"username\" [(ngModel)]=\"adminCredential.username\" name=\"username\" #username=\"ngModel\" required>\n\t\t\t\t</div>\n\t\t\t\t<div [hidden]=\"username.valid || username.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\tUser name is required.\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your password\" id=\"password\" [(ngModel)]=\"adminCredential.password\" name=\"password\" #password=\"ngModel\" required>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\">Login</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	module.exports = ".eca-background{background-size:cover}#user-login-component{height:calc(100% - 80px);padding:1rem}#user-login-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:31.25%}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:bold;text-align:center}#user-login-component .component-content form .forgot-password{display:block;font-size:0.8rem}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}@media (min-width: 1025px){#user-login-component .component-title{max-width:450px}#user-login-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:450px}#user-login-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(39);
	// Services
	var SessionService_1 = __webpack_require__(110);
	var AdminService_1 = __webpack_require__(101);
	var LogoutComponent = (function () {
	    function LogoutComponent(router, sessionService, adminService) {
	        this.router = router;
	        this.sessionService = sessionService;
	        this.adminService = adminService;
	        // For logout navigate
	        this.devEnv = ['auth.eca.dev.nascorp.vn', 'camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn', 'reen.eca.dev.nascorp.vn'];
	        this.testEnv = ['auth.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn'];
	        this.stagingEnv = ['auth.eca.uat.nascorp.vn', 'services.eca.uat.nascorp.vn', 'asa.eca.uat.nascorp.vn', 'holidayschool.eca.uat.nascorp.vn', 'bus.eca.uat.nascorp.vn', 'outdooreducation.eca.uat.nascorp.vn', 'reen.eca.uat.nascorp.vn', 'acs.eca.uat.nascorp.vn', 'pcbs.eca.uat.nascorp.vn'];
	        this.procEnv = ['auth.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com'];
	    }
	    LogoutComponent.prototype.ngOnInit = function () {
	        // Delete session from system
	        this.hostName = window.location.hostname;
	        this.deleteSession();
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    /**
	     * Delete user session data.
	     */
	    LogoutComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.dev.nascorp.vn';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.uat.nascorp.vn';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    // Redirect to desired url
	    LogoutComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return LogoutComponent;
	}());
	LogoutComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-logout',
	        template: '',
	        styles: []
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        SessionService_1.SessionService,
	        AdminService_1.AdminService])
	], LogoutComponent);
	exports.LogoutComponent = LogoutComponent;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(39);
	var LoginComponent_1 = __webpack_require__(122);
	var LogoutComponent_1 = __webpack_require__(126);
	var adminRoutes = [
	    {
	        path: 'login',
	        component: LoginComponent_1.LoginComponent
	    },
	    {
	        path: 'logout',
	        component: LogoutComponent_1.LogoutComponent
	    }
	];
	exports.adminRouting = router_1.RouterModule.forChild(adminRoutes);


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Admin = (function () {
	    function Admin() {
	    }
	    return Admin;
	}());
	exports.Admin = Admin;
	var Interview = (function () {
	    function Interview() {
	    }
	    return Interview;
	}());
	exports.Interview = Interview;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(39);
	var AdminService_1 = __webpack_require__(101);
	var LocalNetworkService_1 = __webpack_require__(87);
	__webpack_require__(130);
	var AppComponent = (function () {
	    function AppComponent(router, adminService, localNetworkService) {
	        this.router = router;
	        this.adminService = adminService;
	        this.localNetworkService = localNetworkService;
	        this.redirectUrl = '/navigate';
	        // Detect show/hide sidebar
	        this.toggleSidebar = false;
	        this.module = 'auth';
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        // Get hostname
	        this.hostName = window.location.hostname;
	        // this.getLocal();
	        // Detect route to show sidebar
	        this.toggleSidebar = this.router.url == '/navigate' ? false : true;
	    };
	    // Detect local or public network
	    AppComponent.prototype.getLocal = function () {
	        var _this = this;
	        this.localNetworkService.getLocalNetWork()
	            .subscribe(function (result) {
	            _this.adminData = _this.adminService.getAdminSessionData();
	            _this.redirect(_this.redirectUrl);
	        }, function (err) {
	            if (_this.adminData) {
	                _this.redirect(_this.redirectUrl);
	            }
	        });
	    };
	    // Redirect function
	    AppComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return AppComponent;
	}());
	AppComponent = __decorate([
	    core_1.Component({
	        selector: 'my-app',
	        template: __webpack_require__(144),
	        styles: [__webpack_require__(145)]
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        AdminService_1.AdminService,
	        LocalNetworkService_1.LocalNetworkService])
	], AppComponent);
	exports.AppComponent = AppComponent;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports) {

	module.exports = "<!-- Application Top Menu -->\n<top-menu></top-menu>\n<!-- Application Main Menu -->\n<admin-header-auth [module]=\"module\"></admin-header-auth>\n<!-- Application Header -->\n<!-- <admin-header [module]=\"module\"></admin-header> -->\n<!-- Application Sidebar -->\n<div class=\"body-auth\">\n    <admin-sidebar [module]=\"module\" *ngIf=\"!toggleSidebar\"></admin-sidebar>\n    <!-- Application Content -->\n    <router-outlet></router-outlet>\n</div>\n<!-- Application Footer -->\n<footer></footer>\n<!-- Application Inspired -->\n<inspired></inspired>";

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = ".body-auth{background:#fff;max-width:100%}.body-auth:before{content:' ';display:table}\n"

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(39);
	var CalendarComponent_1 = __webpack_require__(38);
	var NavigateComponent_1 = __webpack_require__(147);
	var appRoutes = [
	    { path: "", redirectTo: "login", pathMatch: "full" },
	    {
	        path: "navigate",
	        component: NavigateComponent_1.NavigateComponent,
	    },
	    { path: "calendars", component: CalendarComponent_1.CalendarComponent },
	];
	exports.appRoutingProviders = [];
	exports.routing = router_1.RouterModule.forRoot(appRoutes);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(39);
	var AdminService_1 = __webpack_require__(101);
	var SessionService_1 = __webpack_require__(110);
	var UserService_1 = __webpack_require__(98);
	var NavigateComponent = (function () {
	    function NavigateComponent(router, userService, sessionService, adminService) {
	        this.router = router;
	        this.userService = userService;
	        this.sessionService = sessionService;
	        this.adminService = adminService;
	        this.devEnv = [
	            'auth.eca.dev.nascorp.vn',
	            'myais.eca.dev.nascorp.vn',
	            'camp.eca.dev.nascorp.vn',
	            'asa.eca.dev.nascorp.vn',
	            'holiday.eca.dev.nascorp.vn',
	            'bus.eca.dev.nascorp.vn',
	            'conference.eca.dev.nascorp.vn',
	            'acs.eca.dev.nascorp.vn',
	            'kidzone.eca.dev.nascorp.vn'
	        ];
	        this.localEnv = [
	            'auth.local.eca.dev.nascorp.vn',
	            'myais.local.eca.dev.nascorp.vn',
	            'kidzone.local.eca.dev.nascorp.vn'
	        ];
	        this.testEnv = [
	            'auth.eca.test.nascorp.vn',
	            'myais.eca.test.nascorp.vn',
	            'camp.eca.test.nascorp.vn',
	            'asa.eca.test.nascorp.vn',
	            'holiday.eca.test.nascorp.vn',
	            'bus.eca.test.nascorp.vn',
	            'conference.eca.test.nascorp.vn',
	            'acs.eca.dev.nascorp.vn'
	        ];
	        this.stagingEnv = [
	            'auth.eca.uat.nascorp.vn',
	            'services.eca.uat.nascorp.vn',
	            'asa.eca.uat.nascorp.vn',
	            'holidayschool.eca.uat.nascorp.vn',
	            'bus.eca.uat.nascorp.vn',
	            'outdooreducation.eca.uat.nascorp.vn',
	            'reen.eca.uat.nascorp.vn',
	            'acs.eca.uat.nascorp.vn',
	            'pcbs.eca.uat.nascorp.vn'
	        ];
	        this.procEnv = [
	            'auth.aisvietnam.com',
	            'myais.vn',
	            'outdooreducation.aisvietnam.com',
	            'asa.aisvietnam.com',
	            'holidayschool.aisvietnam.com',
	            'bus.aisvietnam.com',
	            'pcbs.aisvietnam.com',
	            'acs.aisvietnam.com'
	        ];
	        this.sidebarStatus = false;
	    }
	    NavigateComponent.prototype.ngOnInit = function () {
	        this.getSession();
	        this.sidebarStatus = false;
	        this.hostName = window.location.hostname;
	    };
	    NavigateComponent.prototype.toAsa = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href = 'https://asa.aisvietnam.com/asa/admin/';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href =
	                    'http://asa.eca.dev.nascorp.vn/asa/admin/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://asa.eca.test.nascorp.vn/asa/admin/';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://asa.eca.uat.nascorp.vn/asa/admin/';
	                break;
	            default:
	                window.location.href =
	                    'http://asa.local.eca.dev.nascorp.vn/asa/admin/';
	                break;
	        }
	    };
	    NavigateComponent.prototype.toHoliday = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href =
	                    'https://holidayschool.aisvietnam.com/holiday/admin/';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href =
	                    'http://holiday.eca.dev.nascorp.vn/holiday/admin/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://holiday.eca.test.nascorp.vn/holiday/admin/';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://holidayschool.eca.uat.nascorp.vn/holiday/admin/';
	                break;
	            default:
	                window.location.href =
	                    'http://holiday.local.eca.dev.nascorp.vn/holiday/admin/';
	                break;
	        }
	    };
	    NavigateComponent.prototype.toCamp = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href =
	                    'https://outdooreducation.aisvietnam.com/camp/admin/';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href =
	                    'http://camp.eca.dev.nascorp.vn/camp/admin/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://camp.eca.test.nascorp.vn/camp/admin/';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://outdooreducation.eca.uat.nascorp.vn/camp/admin/';
	                break;
	            default:
	                window.location.href =
	                    'http://camp.local.eca.dev.nascorp.vn/camp/admin';
	                break;
	        }
	    };
	    NavigateComponent.prototype.toBus = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href = 'https://bus.aisvietnam.com/bus/admin/';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href =
	                    'http://bus.eca.dev.nascorp.vn/bus/admin/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://bus.eca.test.nascorp.vn/bus/admin/';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://bus.eca.uat.nascorp.vn/bus/admin/';
	                break;
	            default:
	                window.location.href = 'http://bus.local.eca.dev.nascorp.vn/';
	                break;
	        }
	    };
	    NavigateComponent.prototype.toConferenceBooking = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href =
	                    'https://pcbs.aisvietnam.com/conference/admin/';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href =
	                    'http://conference.eca.dev.nascorp.vn/conference/admin/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://conference.eca.test.nascorp.vn/conference/admin/';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://pcbs.eca.uat.nascorp.vn/conference/admin/';
	                break;
	            default:
	                window.location.href =
	                    'http://conference.local.eca.dev.nascorp.vn/conference/admin/';
	                break;
	        }
	    };
	    NavigateComponent.prototype.toAccessControl = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href = 'https://acs.aisvietnam.com/';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href = 'http://acs.eca.dev.nascorp.vn/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://acs.eca.test.nascorp.vn/';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://acs.eca.uat.nascorp.vn/';
	                break;
	            default:
	                window.location.href =
	                    'http://acs.local.eca.dev.nascorp.vn/';
	                break;
	        }
	    };
	    NavigateComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession().subscribe(function (user) {
	            _this.userData = user;
	            // this.adminData = this.adminService.getAdminSessionData();
	            // this.role = this.adminData.role
	            _this.role = _this.userData.role;
	            console.log(_this.role);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = '';
	            _this.messageType = 'alert';
	        });
	    };
	    NavigateComponent.prototype.toEdPay = function () {
	        window.location.href = '/api/sso/edpay/token';
	    };
	    NavigateComponent.prototype.toMyAis = function () {
	        switch (this.hostName) {
	            case "auth.aisvietnam.com":
	                window.location.href =
	                    "https://auth.aisvietnam.com/calendars";
	                break;
	            case "auth.eca.dev.nascorp.vn":
	                window.location.href =
	                    "http://auth.eca.dev.nascorp.vn/calendars";
	                break;
	            case "auth.eca.test.nascorp.vn":
	                window.location.href =
	                    "http://auth.eca.test.nascorp.vn/calendars";
	                break;
	            case "auth.eca.uat.nascorp.vn":
	                window.location.href =
	                    "http://auth.eca.uat.nascorp.vn/calendars";
	                break;
	            default:
	                window.location.href =
	                    "http://auth.local.eca.dev.nascorp.vn/calendars";
	                break;
	        }
	        // this.myAisToken();
	        // window.open('http://myais.vn', '_blank')
	    };
	    // Convert string SHA1
	    NavigateComponent.prototype.SHA1 = function (msg) {
	        function rotate_left(n, s) {
	            var t4 = (n << s) | (n >>> (32 - s));
	            return t4;
	        }
	        function lsb_hex(val) {
	            var str = '';
	            var i;
	            var vh;
	            var vl;
	            for (i = 0; i <= 6; i += 2) {
	                vh = (val >>> (i * 4 + 4)) & 0x0f;
	                vl = (val >>> (i * 4)) & 0x0f;
	                str += vh.toString(16) + vl.toString(16);
	            }
	            return str;
	        }
	        function cvt_hex(val) {
	            var str = '';
	            var i;
	            var v;
	            for (i = 7; i >= 0; i--) {
	                v = (val >>> (i * 4)) & 0x0f;
	                str += v.toString(16);
	            }
	            return str;
	        }
	        function Utf8Encode(string) {
	            string = string.replace(/\r\n/g, '\n');
	            var utftext = '';
	            for (var n = 0; n < string.length; n++) {
	                var c = string.charCodeAt(n);
	                if (c < 128) {
	                    utftext += String.fromCharCode(c);
	                }
	                else if (c > 127 && c < 2048) {
	                    utftext += String.fromCharCode((c >> 6) | 192);
	                    utftext += String.fromCharCode((c & 63) | 128);
	                }
	                else {
	                    utftext += String.fromCharCode((c >> 12) | 224);
	                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
	                    utftext += String.fromCharCode((c & 63) | 128);
	                }
	            }
	            return utftext;
	        }
	        var blockstart;
	        var i, j;
	        var W = new Array(80);
	        var H0 = 0x67452301;
	        var H1 = 0xefcdab89;
	        var H2 = 0x98badcfe;
	        var H3 = 0x10325476;
	        var H4 = 0xc3d2e1f0;
	        var A, B, C, D, E;
	        var temp;
	        msg = Utf8Encode(msg);
	        var msg_len = msg.length;
	        var word_array = new Array();
	        for (i = 0; i < msg_len - 3; i += 4) {
	            j =
	                (msg.charCodeAt(i) << 24) |
	                    (msg.charCodeAt(i + 1) << 16) |
	                    (msg.charCodeAt(i + 2) << 8) |
	                    msg.charCodeAt(i + 3);
	            word_array.push(j);
	        }
	        switch (msg_len % 4) {
	            case 0:
	                i = 0x080000000;
	                break;
	            case 1:
	                i = (msg.charCodeAt(msg_len - 1) << 24) | 0x0800000;
	                break;
	            case 2:
	                i =
	                    (msg.charCodeAt(msg_len - 2) << 24) |
	                        (msg.charCodeAt(msg_len - 1) << 16) |
	                        0x08000;
	                break;
	            case 3:
	                i =
	                    (msg.charCodeAt(msg_len - 3) << 24) |
	                        (msg.charCodeAt(msg_len - 2) << 16) |
	                        (msg.charCodeAt(msg_len - 1) << 8) |
	                        0x80;
	                break;
	        }
	        word_array.push(i);
	        while (word_array.length % 16 != 14)
	            word_array.push(0);
	        word_array.push(msg_len >>> 29);
	        word_array.push((msg_len << 3) & 0x0ffffffff);
	        for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
	            for (i = 0; i < 16; i++)
	                W[i] = word_array[blockstart + i];
	            for (i = 16; i <= 79; i++)
	                W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
	            A = H0;
	            B = H1;
	            C = H2;
	            D = H3;
	            E = H4;
	            for (i = 0; i <= 19; i++) {
	                temp =
	                    (rotate_left(A, 5) +
	                        ((B & C) | (~B & D)) +
	                        E +
	                        W[i] +
	                        0x5a827999) &
	                        0x0ffffffff;
	                E = D;
	                D = C;
	                C = rotate_left(B, 30);
	                B = A;
	                A = temp;
	            }
	            for (i = 20; i <= 39; i++) {
	                temp =
	                    (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) &
	                        0x0ffffffff;
	                E = D;
	                D = C;
	                C = rotate_left(B, 30);
	                B = A;
	                A = temp;
	            }
	            for (i = 40; i <= 59; i++) {
	                temp =
	                    (rotate_left(A, 5) +
	                        ((B & C) | (B & D) | (C & D)) +
	                        E +
	                        W[i] +
	                        0x8f1bbcdc) &
	                        0x0ffffffff;
	                E = D;
	                D = C;
	                C = rotate_left(B, 30);
	                B = A;
	                A = temp;
	            }
	            for (i = 60; i <= 79; i++) {
	                temp =
	                    (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) &
	                        0x0ffffffff;
	                E = D;
	                D = C;
	                C = rotate_left(B, 30);
	                B = A;
	                A = temp;
	            }
	            H0 = (H0 + A) & 0x0ffffffff;
	            H1 = (H1 + B) & 0x0ffffffff;
	            H2 = (H2 + C) & 0x0ffffffff;
	            H3 = (H3 + D) & 0x0ffffffff;
	            H4 = (H4 + E) & 0x0ffffffff;
	        }
	        temp =
	            cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);
	        return temp.toLowerCase();
	    };
	    NavigateComponent.prototype.myAisToken = function () {
	        if (this.userData) {
	            var randomChar = Math.random()
	                .toString(36)
	                .substr(2, 4);
	            var firstConvert = this.SHA1('a#BAC@21' + randomChar);
	            this.myaisToken = randomChar.concat(firstConvert);
	            if (this.devEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.eca.dev.nascorp.vn/loginservice/" + this.myaisToken);
	            }
	            else if (this.testEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.eca.test.nascorp.vn/loginservice/" + this.myaisToken);
	            }
	            else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.eca.uat.nascorp.vn/loginservice/" + this.myaisToken);
	            }
	            else if (this.procEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.vn/loginservice/" + this.myaisToken);
	            }
	            else if (this.localEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href = "http://myais.eca.dev.nascorp.vn/loginservice/" + this.myaisToken);
	            }
	        }
	        else {
	            // Redirect to desired URL
	            if (this.devEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href =
	                    'http://services.eca.dev.nascorp.vn');
	            }
	            else if (this.testEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href =
	                    'http://services.eca.test.nascorp.vn');
	            }
	            else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href =
	                    'http://services.eca.uat.nascorp.vn');
	            }
	            else if (this.procEnv.indexOf(this.hostName) !== -1) {
	                return (window.location.href =
	                    'https://services.aisvietnam.com');
	            }
	            else {
	                return (window.location.href =
	                    'http://services.local.eca.dev.nascorp.vn');
	            }
	        }
	    };
	    // toHandbook() {
	    //     window.open(
	    //         '',
	    //         '_blank'
	    //     );
	    // }
	    NavigateComponent.prototype.toReen = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href =
	                    'https://reen.aisvietnam.com/reen/admin/';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href =
	                    'http://reen.eca.dev.nascorp.vn/reen/admin/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://reen.eca.test.nascorp.vn/reen/admin/';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://reen.eca.uat.nascorp.vn/reen/admin/';
	                break;
	            default:
	                window.location.href =
	                    'http://reen.local.eca.dev.nascorp.vn/reen/admin/';
	                break;
	        }
	    };
	    NavigateComponent.prototype.toEnrolment = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href =
	                    'https://apply.aisvietnam.com/admin/';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href =
	                    'http://enrolment.eca.dev.nascorp.vn/admin/';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://enrolment.eca.test.nascorp.vn/admin/';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://apply.eca.uat.nascorp.vn/admin/';
	                break;
	            default:
	                window.location.href =
	                    'http://enrolment.local.eca.dev.nascorp.vn/admin/';
	                break;
	        }
	    };
	    NavigateComponent.prototype.toKidZone = function () {
	        switch (this.hostName) {
	            case 'auth.aisvietnam.com':
	                window.location.href =
	                    'https://kidzone.aisvietnam.com/admin';
	                break;
	            case 'auth.eca.dev.nascorp.vn':
	                window.location.href =
	                    'http://kidzone.eca.dev.nascorp.vn/admin';
	                break;
	            case 'auth.eca.test.nascorp.vn':
	                window.location.href =
	                    'http://kidzone.eca.test.nascorp.vn/admin';
	                break;
	            case 'auth.eca.uat.nascorp.vn':
	                window.location.href =
	                    'http://kidzone.uat.nascorp.vn/admin';
	                break;
	            default:
	                window.location.href =
	                    'http://kidzone.local.eca.dev.nascorp.vn/admin';
	                break;
	        }
	    };
	    return NavigateComponent;
	}());
	NavigateComponent = __decorate([
	    core_1.Component({
	        selector: 'navigate-page',
	        template: __webpack_require__(148),
	        styles: [__webpack_require__(149)]
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        UserService_1.UserService,
	        SessionService_1.SessionService,
	        AdminService_1.AdminService])
	], NavigateComponent);
	exports.NavigateComponent = NavigateComponent;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n  <div class=\"component-title\">\n    <h1>PLEASE SELECT</h1>\n  </div>\n  <div class=\"component-content\">\n    <ul class=\"row\" *ngIf=\"role  === 'system' || role  === 'manager'\">\n      <li (click)=\"toAsa()\">\n        <span>ASA MANAGEMENT</span>\n      </li>\n      <li (click)=\"toHoliday()\">\n        <span>HOLIDAY MANAGEMENT</span>\n      </li>\n      <li (click)=\"toMyAis()\">\n        <span>AIS EVENTS CALENDAR</span>\n      </li>\n    </ul>\n    <ul\n      class=\"row\"\n      class=\"custom-navigate\"\n      *ngIf=\"role  === 'system' || role  === 'manager'\"\n    >\n      <li (click)=\"toCamp()\">\n        <span>CAMP MANAGEMENT</span>\n      </li>\n      <!-- <li (click)=\"toReen()\">\n                <span>RE-ENROLMENT</span>\n            </li>\n            <li (click)=\"toAccessControl()\" *ngIf=\"role  === 'system'\">\n                <span>ACCESS CONTROL</span>\n            </li>\n            <li (click)=\"toEnrolment()\" *ngIf=\"role  === 'system'\">\n                <span>ENROLMENT</span>\n            </li> -->\n      <li (click)=\"toKidZone()\" *ngIf=\"role  === 'system'\">\n        <span>KIDZONE</span>\n      </li>\n    </ul>\n    <ul class=\"row\" *ngIf=\"role === 'student'\" class=\"student-navigate\">\n      <li class=\"large-2\" (click)=\"toMyAis()\">\n        <span>AIS EVENTS CALENDAR</span>\n      </li>\n    </ul>\n    <ul class=\"row\" *ngIf=\"role === 'parent'\">\n      <li (click)=\"toEdPay()\">\n        <span>EDPAY</span>\n      </li>\n    </ul>\n  </div>\n</div>\n";

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = ".eca-background{background-size:cover}#user-login-component{height:100%;padding:1rem}#user-login-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:100%}#user-login-component .component-content ul{text-align:center;display:flex}#user-login-component .component-content ul li{list-style:none;display:block;padding:2rem;background:#fff;border-radius:5px;font-size:0.875rem;font-weight:bold;margin:0.5rem;opacity:0.8;color:#043D7A;cursor:pointer;flex:1}.student-navigate li{margin:0 auto !important}.custom-navigate{justify-content:center}.custom-navigate li{max-width:250px}\n"

/***/ })
]);


// WEBPACK FOOTER //
// app.70bae61ee8c4c5600c92.js